<template>
  <div class="grid pb-0">
    <div class="grid-body border-top-unset" style="height: calc(100vh - 143px)">
      <div class="body-room-sale">
        <v-card-text>
          <v-row align="center">
            <v-col sm="3" class="pt-0 pb-0">
              <label>
                {{ $t("ROOM_TYPE") }}
              </label>
              <treeselect
                :multiple="true"
                :options="listRoomTypeByRoomCategory"
                :placeholder="$t('_BATCH_UPDATE.SELECT_ROOM_TYPE')"
                :limit="1"
                @close="change()"
                @open="open()"
                :limitText="fnCount"
                v-model="selectedRoom"
              >
                <div
                  slot="value-label"
                  slot-scope="{ node }"
                  class="text-truncate"
                  style="max-width: 100px"
                  :title="node.raw.label"
                >
                  {{ node.raw.label }}
                </div>
              </treeselect>
            </v-col>
            <v-col sm="3" class="pt-0 pb-0">
              <label>
                {{ $t("SALE_PACKAGE") }}
              </label>
              <treeselect
                :multiple="true"
                :options="listRatePlanByRateCategory"
                :placeholder="$t('SELECT_SALE_PACKAGE')"
                :limit="1"
                @close="change()"
                @open="open()"
                :limitText="fnCount"
                v-model="selectedSalePackage"
              >
                <div
                  slot="value-label"
                  slot-scope="{ node }"
                  class="text-truncate"
                  style="max-width: 100px"
                  :title="node.raw.label"
                >
                  {{ node.raw.label }}
                </div>
              </treeselect>
            </v-col>
            <v-col class="pt-0 pb-0">
              <label>
                {{ $t("SHOW_MORE") }}
              </label>
              <v-autocomplete
                item-text="text"
                item-value="value"
                :items="listMetaData"
                v-model="selectedMetaData"
                outlined
                dense
                multiple
                chips
                @change="changeMeta(selectedMetaData)"
              >
                <template v-slot:selection="{ item, index }">
                  <v-chip
                    color="primary"
                    v-if="index === 0 || index === 1"
                    v-bind="item.attrs"
                    :input-value="item.selected"
                    close
                    @click:close="
                      removeChips(index, selectedMetaData);
                      changeMeta(selectedMetaData);
                    "
                  >
                    <span>{{ item.text }}</span>
                  </v-chip>
                  <span v-if="index === 2" class="grey--text caption"
                    >(+{{ selectedMetaData.length - 2 }})</span
                  >
                </template>
                <template slot="no-data">
                  <div class="no-data">{{ $t("NO_DATA") }}</div>
                </template>
              </v-autocomplete>
            </v-col>
          </v-row>
        </v-card-text>

        <template>
          <div
            v-if="isLoading == false"
            class="max-height-table"
            :style="{ 'max-height': maxHeight + 'px' }"
            ref="scrollableDiv"
            @mousedown="startScrolling"
            @mousemove="handleMouseMove"
            @mouseup="stopScrolling"
            @mouseleave="stopScrolling"
            @scroll="loadData"
          >
            <table class="room-sale-table" style="user-select: none;">
              <tr>
                <td class="table-left">
                  <table class="table-left-content">
                    <thead>
                      <tr>
                        <th colspan="2">
                          <div class="header-wrapper calendar">
                            <v-icon
                              light
                              left
                              color="#003e94"
                              size="40"
                              @click="prevMonth()"
                              >chevron_left</v-icon
                            >
                            <date-picker
                              :model.sync="selectedDatePicker"
                              :min="currentDatePicker"
                              :max="maxDate"
                              format="DD/MM/YYY"
                              class="outlined"
                              dense
                              outlined
                            />
                            <v-icon
                              light
                              right
                              color="#003e94"
                              size="40"
                              @click="nextMonth()"
                              >chevron_right</v-icon
                            >
                          </div>
                        </th>
                      </tr>
                    </thead>
                    <tbody>
                      <template v-for="(room, i) in relationData">
                        <tr :key="'left_table_row_1_'+i">
                          <td
                            class="room-row border-right"
                            :rowspan="selectedMetaData.includes('HOTEL_ROOM_RATE') ? 2 : 1"
                          >
                            <div
                              class="px-2 d-flex justify-content-between border-0 text-nowrap align-items-center"
                            >
                              <div
                                class="font-weight-bold d-flex"
                                :title="findName(room.roomTypeI18n)"
                              >
                                <div class="text-truncate" style="max-width: 150px">
                                  {{ findName(room.roomTypeI18n) }}
                                </div>
                                <div class="ml-2">
                                  ({{ $t("HOTEL_LOG_id") }}: {{ room.roomCode }})
                                </div>
                              </div>
                              <v-tooltip top v-if="room.parent">
                                <template v-slot:activator="{ on, attrs }">
                                  <span class="txt-child ml-auto" v-bind="attrs" v-on="on"
                                    >D</span
                                  >
                                </template>
                                <span
                                  >{{ $t("DERIVE_OF_ROOM") }}:
                                  {{ room.parent.nameVi }}</span
                                >
                              </v-tooltip>

                              <v-menu
                                :close-on-content-click="false"
                                :nudge-width="200"
                                offset-y
                              >
                                <template v-slot:activator="{ on, attrs }">
                                  <v-btn
                                    class="btn-outline-custom pr-0 ml-2 border font-weight-bold"
                                    v-bind="attrs"
                                    v-on="on"
                                    x-small
                                  >
                                    <v-progress-circular
                                      indeterminate
                                      :size="12"
                                      :width="2"
                                      class="mr-2"
                                      color="primary"
                                      v-if="room.isLoading"
                                    ></v-progress-circular>

                                    {{
                                      room.selectedOta.length == 0
                                        ? $t("SELECT_SALE_CHANNEL")
                                        : $tc(
                                            "CHANNEL",
                                            room.selectedOta.length.toString()
                                          )
                                    }}
                                    <i class="icon-drop-down-list fs-14 ml-2"></i>
                                  </v-btn>
                                </template>

                                <v-card>
                                  <v-list>
                                    <v-list-item class="px-2">
                                      <b-form-input
                                        v-model="room.textSearch"
                                        :placeholder="$t('_HOTEL_CHAIN.SEARCH')"
                                        @input="$forceUpdate()"
                                      ></b-form-input>
                                    </v-list-item>
                                    <v-list-item class="px-2">
                                      <p class="mx-3 mt-1 mb-0">
                                        <a
                                          class="text-primary"
                                          @click="
                                            room.selectedOta = listOTA.map(
                                              (e) => e.value
                                            );
                                            getRestrictionByRoomRate(room);
                                            $forceUpdate();
                                          "
                                          >{{ $t("SELECT_ALL") }}</a
                                        >
                                        |
                                        <a
                                          class="text-primary"
                                          @click="
                                            room.selectedOta = [];
                                            getRestrictionByRoomRate(room);
                                            $forceUpdate();
                                          "
                                          >{{ $t("UN_SELECT_ALL") }}</a
                                        >
                                      </p>
                                    </v-list-item>
                                  </v-list>
                                  <v-list style="max-height: 200px; overflow-y: auto">
                                    <v-list-item
                                      style="min-height: 28px !important"
                                      class="px-2"
                                    >
                                      <b-form-group v-slot="{ ariaDescribedby }">
                                        <b-form-checkbox-group
                                          v-model="room.selectedOta"
                                          :options="
                                            listOTA.filter((item) =>
                                              item.text
                                                .toString()
                                                .toLowerCase()
                                                .includes(room.textSearch.toLowerCase())
                                            )
                                          "
                                          :aria-describedby="ariaDescribedby"
                                          name="flavour-2a"
                                          stacked
                                          @change="
                                            getRestrictionByRoomRate(room);
                                            $forceUpdate();
                                          "
                                        ></b-form-checkbox-group>
                                      </b-form-group>
                                    </v-list-item>
                                  </v-list>
                                </v-card>
                              </v-menu>
                            </div>
                          </td>
                          <td class="room-row border-right">
                            <div class="px-2 d-flex justify-content-between txt-nowrap">
                              <span class="pr-3">{{ $t("ROOM_AVAIL") }}</span>
                              <i
                                v-if="syncInventory === false && !room.parent && checkRoleFunc('INVENTORY')"
                                class="icon-edit text-primary fs-16"
                                @click="updateRoomAvail(room.id)"
                              ></i>
                            </div>
                          </td>
                        </tr>
                        <tr :key="'left_table_row_2_'+i" v-if="selectedMetaData.includes('HOTEL_ROOM_RATE')">
                          <td class="room-row border-right">
                            <div class="px-2 d-flex justify-content-between txt-nowrap">
                              <span class="pr-3">{{ $t("HOTEL_ROOM_RATE") }}</span>
                              <i v-if="checkRoleFunc('RATE')"
                                class="icon-edit text-primary fs-16"
                                @click="updateRoomPrice(room.id)"
                              ></i>
                            </div>
                          </td>
                        </tr>

                        <template v-if="room.ratePlans.length > 0">
                          <template v-for="(ratePlan, j1) in room.ratePlans">
                            <tr :key="'left_table_row_3_'+i+'ratePlan_'+ j1" v-if="ratePlan">
                              <td class="border-right">
                                <div
                                  class="lh-13 px-2 d-flex justify-content-between border-0 align-items-center"
                                >
                                  <div class="mr-auto pl-5">
                                    <div
                                      class="d-flex txt-nowrap"
                                      :title="findName(ratePlan.i18ns)"
                                    >
                                      <div class="text-truncate" style="max-width: 150px">
                                        {{ findName(ratePlan.i18ns) }}
                                      </div>
                                      <div class="ml-2">
                                        ({{ $t("HOTEL_LOG_id") }}:
                                        {{ ratePlan.ratePlanCode }})
                                      </div>
                                    </div>
                                  </div>
                                </div>
                              </td>
                              <td class="border-right">
                                <div
                                  class="px-2 d-flex justify-content-between txt-nowrap"
                                >
                                  <span class="pr-3">{{ $t("ROOM_FUND") }}</span>
                                </div>
                              </td>
                            </tr>
                            <template v-for="(rr, ir) in ratePlan.roomRates">
                              <tr :key="'left_table_row_3_'+i+'ratePlan_'+ j1 + 'roomRate_'+ir" v-if="rr">
                                <td class="border-right" :rowspan="rowspanCol(rr.ota.otaCode, metas.length)">
                                  <div
                                    class="lh-13 px-2 d-flex justify-content-between border-0 align-items-center"
                                  >
                                    <div class="mr-auto ml-5">
                                      <div
                                        class="d-flex txt-nowrap pl-3"
                                        :title="findName(rr.ota.otaI18n)"
                                      >
                                        <div
                                          class="text-truncate"
                                          style="max-width: 150px"
                                        >
                                          {{ findName(rr.ota.otaI18n) }}
                                        </div>
                                        <div class="ml-2">
                                          ({{ $t("HOTEL_LOG_id") }}: {{ rr.ota.otaCode }})
                                        </div>
                                      </div>
                                      <div class="flex pl-3">
                                        <div>
                                          <i
                                            class="icon-groups_2 text-primary fs-16"
                                            style="position: relative; top: 3px"
                                          ></i>
                                          <span>
                                            x
                                            {{ rr.guestsIncluded }}</span
                                          >
                                        </div>
                                        <div class="ml-2">
                                          <i class="icon-adult text-primary fs-16"></i>
                                          <span>
                                            x
                                            {{ rr.adultsIncluded }}</span
                                          >
                                        </div>
                                        <div class="ml-2">
                                          <i class="icon-children text-primary fs-16"></i>
                                          <span>
                                            x
                                            {{ rr.childrenIncluded }}</span
                                          >
                                        </div>
                                        <div class="ml-2">
                                          <i
                                            class="icon-child_care text-primary fs-16"
                                            style="position: relative; top: 3px"
                                          ></i>
                                          <span>
                                            x
                                            {{ rr.babiesIncluded }}</span
                                          >
                                        </div>
                                      </div>
                                    </div>
                                    <i
                                      v-if="rr.isPackage"
                                      class="icon-hive fs-16 text-primary mr-2"
                                      :title="$t('PACKAGE_DEAL')"
                                    ></i>

                                    <i
                                      class="icon-delete text-danger fs-16"
                                      @click="
                                        $refs.deleteDialogComponent.open({
                                          room: room,
                                          roomTypeId: room.id,
                                          ratePlanId: ratePlan.id,
                                          roomRate: rr,
                                        })
                                      "
                                      v-if="rr.connectedOTA === 0"
                                    ></i>
                                    <i
                                      class="icon-cloud_done fs-16 text-primary"
                                      v-else-if="rr.connectedOTA === 1"
                                    ></i>
                                    <i
                                      class="icon-cloud_upload fs-16 text-warning"
                                      v-else-if="rr.connectedOTA === 2"
                                    ></i>
                                  </div>
                                </td>
                                <td class="border-right">
                                  <div class="px-2 d-flex justify-content-between">
                                    <span>
                                      {{ $t("SERVICE.PRICE") }} ({{ usedCurrency }})
                                    </span>
                                    <i
                                      class="icon-edit text-primary fs-16"
                                      v-if="
                                        !rr.linkedRoomRateId && rr.ota.otaCode != 'EZ_PMS' && checkRoleFunc('RATE')
                                      "
                                      @click="updatePrice(room.id, ratePlan.id, rr)"
                                    ></i>
                                    <span
                                      v-else-if="rr.linkedRoomRateId"
                                      class="txt-child-primary text-master-rate"
                                      >C</span
                                    >
                                  </div>
                                </td>
                              </tr>
                              <template v-for="(metaData, key) in metas">
                                <tr :key="'left_table_row_3_'+i+'ratePlan_'+ j1 + 'roomRate_'+ir+'restriction_'+key" v-if="rr.ota.otaCode !== 'EZ_BE' && (metaData !== 'minBookingWindow' && metaData !== 'maxBookingWindow')">
                                  <td class="border-right">
                                    <div
                                      class="px-2 d-flex align-items-center text-nowrap"
                                    >
                                      <span class="mr-auto">
                                        <span>
                                          {{
                                            listMetaData.find((x) => x.value == metaData)
                                              .text
                                          }}
                                        </span>
                                      </span>
                                      <i
                                        v-if="(metaData == 'stopSell' || (metaData == 'sellLimit' && !room.parent && rr.ota.otaCode !== 'EZ_PMS')) && checkRoleFunc('STOP_SELL_LIMIT')"
                                        class="icon-edit text-primary fs-16"
                                        @click="updateStopSell(room.id, ratePlan.id, rr, metaData)"
                                      ></i>
                                      <i
                                      v-else-if="metaData != 'pricePax' &&
                                        metaData != 'priceExtraAdult' &&
                                        metaData != 'priceExtraChild' &&
                                        metaData != 'priceExtraBaby' &&
                                        metaData != 'stopSell' && 
                                        metaData != 'sellInventory' &&
                                        metaData != 'sellLimit' && checkRoleFunc('RESTRICTION')"
                                        class="icon-edit text-primary fs-16"
                                        @click="
                                          updateRestriction(
                                            room.id,
                                            ratePlan.id,
                                            rr,
                                            metaData
                                          )
                                        "
                                      ></i>
                                      <i
                                        v-else-if="checkRoleFunc('RATE') && !['sellInventory', 'stopSell', 'sellLimit'].includes(metaData)"
                                        class="icon-edit text-primary fs-16"
                                        @click="updateSpecialPrice(room.id, ratePlan.id, rr, metaData)"
                                      ></i>
                                    </div>
                                  </td>
                                </tr>
                                <tr :key="'left_table_row_4_'+i+'ratePlan_'+ j1 + 'roomRate_'+ir+'restriction_'+key+'_EZ_BE'" v-if="rr.ota.otaCode === 'EZ_BE'">
                                  <td class="border-right">
                                    <div
                                      class="px-2 d-flex align-items-center text-nowrap"
                                    >
                                      <span class="mr-auto">
                                        <span>
                                          {{
                                            listMetaData.find((x) => x.value == metaData)
                                              .text
                                          }}
                                        </span>
                                      </span>
                                      <i
                                        v-if="(metaData == 'stopSell' || (metaData == 'sellLimit' && !room.parent && rr.ota.otaCode !== 'EZ_PMS')) && checkRoleFunc('STOP_SELL_LIMIT')"
                                        class="icon-edit text-primary fs-16"
                                        @click="updateStopSell(room.id, ratePlan.id, rr, metaData)"
                                      ></i>
                                      <i
                                      v-else-if="metaData != 'pricePax' &&
                                        metaData != 'priceExtraAdult' &&
                                        metaData != 'priceExtraChild' &&
                                        metaData != 'priceExtraBaby' &&
                                        metaData != 'stopSell' && 
                                        metaData != 'sellInventory' &&
                                        metaData != 'sellLimit' && checkRoleFunc('RESTRICTION')"
                                        class="icon-edit text-primary fs-16"
                                        @click="
                                          updateRestriction(
                                            room.id,
                                            ratePlan.id,
                                            rr,
                                            metaData
                                          )
                                        "
                                      ></i>
                                      <i
                                        v-else-if="checkRoleFunc('RATE') && !['sellInventory', 'stopSell', 'sellLimit'].includes(metaData)"
                                        class="icon-edit text-primary fs-16"
                                        @click="updateSpecialPrice(room.id, ratePlan.id, rr, metaData)"
                                      ></i>
                                    </div>
                                  </td>
                                </tr>
                              </template>
                            </template>
                          </template>
                        </template>
                      </template>
                    </tbody>
                  </table>
                </td>
                <td class="table-right">
                  <table class="table-right-content">
                    <thead>
                      <tr>
                        <template v-for="(item, i) in dateList">
                          <th
                            :key="'dateList_right_'+i"
                            v-if="item"
                            :class="{ 'weekend-header': item.isWeekend }"
                            class="border-right"
                          >
                            <div class="header-wrapper border-0">
                              <div class="date" v-html="item.dateFormat"></div>
                            </div>
                          </th>
                        </template>
                      </tr>
                    </thead>
                    <tbody @mouseleave="checkMouseLeave()">
                      <template v-for="(room, i) in relationData">
                        <tr :key="'right_relationData_row1_'+i">
                          <td
                            class="room-row border-right"
                            v-for="(avail, key) in dateList"
                            :class="[
                              { 'weekend-body': avail.isWeekend }
                            ]"
                            :key="'right_relationData_row1_'+i+'dateList_'+key"
                          >
                            <div
                              class="body-wrapper"
                              :class="{'cursor': checkIsUpdate(room, null, null, 'inventory')}"
                              @mousedown="startSelect(room,null, null, avail.date, 'inventory')"
                              @mouseenter="continueSelect(room,null, null, avail.date, 'inventory')"
                              @mouseup="endSelect(room, null, null, avail.date, 'inventory')"
                            >
                              <template v-if="room.availByDate[avail.date]">
                                <div
                                  class="vertical-divider border-0"
                                  :class="[
                                  { 'empty': room.availByDate[avail.date][0].quantity === 0 },
                                  { 'over': room.availByDate[avail.date][0].quantity < 0 },
                                  {'date-selected': 
                                    quickUpdate.dateMove.includes(avail.date) && 
                                    quickUpdate.restriction == 'inventory' && 
                                    room.id == quickUpdate.room.id}
                                  ]"
                                >
                                  <span>
                                    {{ room.availByDate[avail.date][0].quantity }}
                                  </span>
                                </div>
                              </template>
                              <template v-else>
                                <div class="vertical-divider border-0">
                                  <span>-</span>
                                </div>
                              </template>
                            </div>
                          </td>
                        </tr>
                        <tr 
                          :key="'right_relationData_row2_'+i" 
                          v-if="selectedMetaData.find((e) => e === 'HOTEL_ROOM_RATE')"
                        >
                          <td
                            class="room-row border-right"
                            v-for="(room_price, key1) in dateList"
                            :class="[
                              { 'weekend-body': room_price.isWeekend },
                              {'date-selected': 
                              quickUpdate.dateMove.includes(room_price.date) && 
                              quickUpdate.restriction == 'HOTEL_ROOM_RATE' && 
                              room.id == quickUpdate.room.id
                              }
                            ]"
                            @mousedown="startSelect(room,null, null, room_price.date, 'HOTEL_ROOM_RATE')"
                            @mouseenter="continueSelect(room,null, null, room_price.date, 'HOTEL_ROOM_RATE')"
                            @mouseup="endSelect(room, null, null, room_price.date, 'HOTEL_ROOM_RATE')"
                            :key="'right_relationData_row2_'+i+'dateList_'+key1"
                          >
                            <div
                              class="body-wrapper"
                              :class="{'cursor': checkIsUpdate(room, null, null, 'HOTEL_ROOM_RATE')}"
                            >
                              <template v-if="room_price.isWeekend">
                                <div class="vertical-divider border-0">
                                  <span
                                    :class="
                                      checkSpecialPriceRoom(room, room_price.date)
                                        ? 'font-weight-bold'
                                        : ''
                                    "
                                  >
                                    {{
                                      checkSpecialPriceRoom(room, room_price.date)
                                        ? numberFormat(
                                            checkSpecialPriceRoom(room, room_price.date)
                                          )
                                        : numberFormat(room.weekendPrice)
                                    }}
                                  </span>
                                </div>
                              </template>
                              <template v-else>
                                <div class="vertical-divider border-0">
                                  <span
                                    :class="
                                      checkSpecialPriceRoom(room, room_price.date)
                                        ? 'font-weight-bold'
                                        : ''
                                    "
                                  >
                                    {{
                                      checkSpecialPriceRoom(room, room_price.date)
                                        ? numberFormat(
                                            checkSpecialPriceRoom(room, room_price.date)
                                          )
                                        : numberFormat(room.defaultPrice)
                                    }}
                                  </span>
                                </div>
                              </template>
                            </div>
                          </td>
                        </tr>
                        <template v-if="room.ratePlans.length > 0">
                          <template v-for="(ratePlan, j1) in room.ratePlans">
                            <tr :key="'right_relationData_row3_'+i+ '_ratePlan_'+j1"  v-if="ratePlan">
                              <td
                                class="border-right"
                                v-for="(avail, index) in dateList"
                                :class="{ 'weekend-body': avail.isWeekend }"
                                :key="'right_relationData_row3_'+i+'_ratePlan_'+j1+'_dateList_'+index"
                                @mouseup="endSelectNotAllowed()"
                              >
                                <div class="body-wrapper">
                                  <template>
                                    <div class="vertical-divider border-0">
                                      <span>-</span>
                                    </div>
                                  </template>
                                </div>
                              </td>
                            </tr>
                            <template v-for="(rr, ir) in ratePlan.roomRates">
                              <tr :key="'right_relationData_row4_'+i+ '_ratePlan_'+j1+'_roomRates_'+ir">
                                <td
                                  class="border-right"
                                  v-for="(avail, index) in dateList"
                                  :class="[
                                  { 'weekend-body': avail.isWeekend },
                                  {'cursor': checkIsUpdate(room, ratePlan, rr, 'price')}
                                  ]"
                                  @mousedown="startSelect(room,ratePlan, rr, avail.date, 'price')"
                                  @mouseenter="continueSelect(room,ratePlan, rr, avail.date, 'price')"
                                  @mouseup="endSelect(room, ratePlan, rr, avail.date, 'price')"
                                  :key="'right_relationData_row4_'+i+ '_ratePlan_'+j1+'_roomRates_'+ir+'_dateList_'+index"
                                >
                                  <template v-if="rr.linkedRoomRateId">
                                    <div
                                      class="body-wrapper"
                                      :class="checkSpecialPrice(rr, avail.date)"
                                    >
                                      <div
                                        class="border-0 px-2 vertical-divider"
                                        :class="[
                                          {'closed': (rr.restrictions.find(e => e.appliedDate == avail.date) || {}).closed},
                                          {'date-selected': 
                                          quickUpdate.dateMove.includes(avail.date) && 
                                          quickUpdate.restriction == 'price' &&
                                          room.id == quickUpdate.room.id &&
                                          ratePlan.id == quickUpdate.ratePlan.id &&
                                          rr.id == quickUpdate.roomRate.id}
                                        ]"
                                      >
                                        <div
                                          v-if="(rr.restrictions.find((e) => e.appliedDate == avail.date) || {}).closedOnArrival"
                                          class="before"
                                        ></div>
                                        <span class="text-master-rate">
                                          {{
                                            checkSpecialPrice(rr, avail.date)
                                              ? numberFormat(
                                                  rr["roomRateSpecials"].find(
                                                    (x) => x.appliedDate == avail.date
                                                  ).pricePax
                                                )
                                              : numberFormat(
                                                  rr[formatDateOfWeekInPrice(avail.date)]
                                                )
                                          }}
                                        </span>
                                        <div
                                          v-if="(rr.restrictions.find((e) => e.appliedDate == avail.date) || {}).closedOnDeparture"
                                          class="after"
                                        ></div>
                                      </div>
                                    </div>
                                  </template>
                                  <template v-else>
                                    <div class="body-wrapper">
                                      <div
                                        class="border-0 px-2 vertical-divider"
                                        :class="[
                                          {'closed': (rr.restrictions.find(e => e.appliedDate == avail.date) || {}).closed},
                                          {'date-selected': 
                                          quickUpdate.dateMove.includes(avail.date) && 
                                          quickUpdate.restriction == 'price' &&
                                          room.id == quickUpdate.room.id &&
                                          ratePlan.id == quickUpdate.ratePlan.id &&
                                          rr.id == quickUpdate.roomRate.id}
                                        ]"
                                      >
                                        <div
                                          v-if="(rr.restrictions.find((e) => e.appliedDate == avail.date) || {}).closedOnArrival"
                                          class="before"
                                        ></div>
                                        <span :class="checkSpecialPrice(rr, avail.date)">
                                          {{
                                            checkSpecialPrice(rr, avail.date)
                                              ? numberFormat(
                                                  rr["roomRateSpecials"].find(
                                                    (x) => x.appliedDate == avail.date
                                                  ).pricePax
                                                )
                                              : numberFormat(
                                                  rr[formatDateOfWeekInPrice(avail.date)]
                                                )
                                          }}
                                        </span>
                                        <div
                                          v-if="(rr.restrictions.find((e) => e.appliedDate == avail.date) || {}).closedOnDeparture"
                                          class="after"
                                        ></div>
                                      </div>
                                    </div>
                                  </template>
                                </td>
                              </tr>
                              <template v-for="(metaData, keyMeta) in metas">
                                <template v-if="rr.ota.otaCode !== 'EZ_BE' && (metaData !== 'minBookingWindow' && metaData !== 'maxBookingWindow')">
                                  <tr
                                    v-if="
                                      metaData != 'priceExtraAdult' &&
                                      metaData != 'priceExtraChild' &&
                                      metaData != 'priceExtraBaby' &&
                                      metaData != 'pricePax' &&
                                      metaData != 'stopSell' &&
                                      metaData != 'sellInventory' &&
                                      metaData != 'sellLimit'
                                    "
                                    :key="'right_relationData_row4_'+i+ '_ratePlan_'+j1+'_roomRates_'+ir+`_${metaData}_`+keyMeta"
                                  >
                                    <td
                                    class="border-right text-center"
                                    v-for="(appliedDate, z2) in dateList"
                                    :class="[
                                      { 'weekend-body': appliedDate.isWeekend },
                                      {'date-selected': 
                                        quickUpdate.dateMove.includes(appliedDate.date) && 
                                        quickUpdate.restriction == metaData &&
                                        room.id == quickUpdate.room.id &&
                                        ratePlan.id == quickUpdate.ratePlan.id &&
                                        rr.id == quickUpdate.roomRate.id},
                                      {'cursor': checkIsUpdate(room, ratePlan, rr, metaData)}
                                    ]"
                                    @mousedown="startSelect(room,ratePlan, rr, appliedDate.date, metaData)"
                                    @mouseenter="continueSelect(room,ratePlan, rr, appliedDate.date, metaData)"
                                    @mouseup="endSelect(room, ratePlan, rr, appliedDate.date, metaData)"
                                    :key="'right_relationData_row4_'+i+ '_ratePlan_'+j1+'_roomRates_'+ir+`_${metaData}_`+keyMeta+'_date_'+z2"
                                    >
                                      <b v-if="
                                        !rr.restrictionsGroupBy[appliedDate.date] ||
                                        rr.restrictionsGroupBy[appliedDate.date][0][metaData] == null ||
                                        (
                                          rr.restrictionsGroupBy[appliedDate.date] &&
                                          rr.restrictionsGroupBy[appliedDate.date][0][metaData] === -1
                                        )"
                                      >-</b>
                                      <template v-else>
                                        <template
                                          v-if="
                                            (metaData == 'closed' ||
                                              metaData == 'closedOnArrival' ||
                                              metaData == 'closedOnDeparture') &&
                                            rr.restrictionsGroupBy[appliedDate.date][0][
                                              metaData
                                            ] === true
                                          "
                                        >
                                          <i
                                            class="icon-Exit text-danger fs-18 font-weight-bold"
                                          ></i>
                                        </template>

                                        <template
                                          v-else-if="
                                            (metaData == 'closed' ||
                                              metaData == 'closedOnArrival' ||
                                              metaData == 'closedOnDeparture') &&
                                            rr.restrictionsGroupBy[appliedDate.date][0][
                                              metaData
                                            ] === false
                                          "
                                        >
                                          <i
                                            class="icon-check text-success fs-16 font-weight-bold"
                                          ></i>
                                        </template>
                                        <template v-else>
                                          {{ rr.restrictionsGroupBy[appliedDate.date][0][metaData]
                                          +''+
                                          (rr.restrictionsGroupBy[appliedDate.date][0][metaData] !== -1 && (metaData.endsWith("ByHour")) ? 'H' : metaData.endsWith("Window") ? 'D' : '') }}
                                        </template>
                                      </template>
                                    </td>
                                  </tr>
                                  <tr 
                                    v-else-if="metaData == 'stopSell'"
                                    :key="'right_relationData_row5_'+i+ '_ratePlan_'+j1+'_roomRates_'+ir+`_${metaData}_`+keyMeta"
                                    >
                                    <td
                                      class="border-right text-center"
                                      v-for="(appliedDate, z3) in dateList"
                                      :class="[
                                        { 'weekend-body': appliedDate.isWeekend },
                                        {'date-selected': 
                                          quickUpdate.dateMove.includes(appliedDate.date) && 
                                          quickUpdate.restriction == metaData &&
                                          room.id == quickUpdate.room.id &&
                                          ratePlan.id == quickUpdate.ratePlan.id &&
                                          rr.id == quickUpdate.roomRate.id},
                                        {'cursor': checkIsUpdate(room, ratePlan, rr, metaData)}
                                      ]"
                                      @mousedown="startSelect(room,ratePlan, rr, appliedDate.date, metaData)"
                                      @mouseenter="continueSelect(room,ratePlan, rr, appliedDate.date, metaData)"
                                      @mouseup="endSelect(room, ratePlan, rr, appliedDate.date, metaData)"
                                      :key="'right_relationData_row4_'+i+ '_ratePlan_'+j1+'_roomRates_'+ir+`_${metaData}_`+keyMeta+'_date_'+z3"
                                    >
                                      <template
                                        v-if="(
                                        restriction = rr.restrictions.find((e) => e.appliedDate === appliedDate.date)) && 
                                        restriction.stopLimit !== null && 
                                        restriction.stopLimit >= 0"
                                      >
                                        <span>
                                          {{restriction.stopLimit}}
                                        </span>
                                      </template>
                                      <template v-else>
                                        <b>-</b>
                                      </template>
                                    </td>
                                  </tr>
                                  <tr 
                                    v-else-if="metaData == 'sellLimit'"
                                    :key="'right_relationData_row5_'+i+ '_ratePlan_'+j1+'_roomRates_'+ir+`_${metaData}_`+keyMeta"
                                  >
                                    <td
                                      class="border-right text-center"
                                      v-for="(appliedDate, z3) in dateList"
                                      :class="[
                                        { 'weekend-body': appliedDate.isWeekend },
                                        {'date-selected': 
                                          quickUpdate.dateMove.includes(appliedDate.date) && 
                                          quickUpdate.restriction == metaData &&
                                          room.id == quickUpdate.room.id &&
                                          ratePlan.id == quickUpdate.ratePlan.id &&
                                          rr.id == quickUpdate.roomRate.id},
                                        {'cursor': checkIsUpdate(room, ratePlan, rr, metaData)}
                                      ]"
                                      @mousedown="startSelect(room,ratePlan, rr, appliedDate.date, metaData)"
                                      @mouseenter="continueSelect(room,ratePlan, rr, appliedDate.date, metaData)"
                                      @mouseup="endSelect(room, ratePlan, rr, appliedDate.date, metaData)"
                                      :key="'right_relationData_row4_'+i+ '_ratePlan_'+j1+'_roomRates_'+ir+`_${metaData}_`+keyMeta+'_date_'+z3"
                                    >
                                      <template
                                        v-if="(
                                        restriction = rr.restrictions.find((e) => e.appliedDate === appliedDate.date)) &&
                                        restriction.sellLimit !== null && 
                                        restriction.sellLimit >= 0"
                                      >
                                        <span>
                                          {{
                                            restriction.sellLimit
                                          }}
                                        </span>
                                      </template>
                                      <template v-else>
                                        <b>-</b>
                                      </template>
                                    </td>
                                  </tr>
                                  <tr 
                                    v-else-if="metaData == 'sellInventory'"
                                    :key="'right_relationData_row5_'+i+ '_ratePlan_'+j1+'_roomRates_'+ir+`_${metaData}_`+keyMeta"
                                  >
                                    <td
                                      class="border-right text-center"
                                      v-for="(appliedDate, z3) in dateList"
                                      :class="{ 'weekend-body': appliedDate.isWeekend }"
                                      :key="'right_relationData_row4_'+i+ '_ratePlan_'+j1+'_roomRates_'+ir+`_${metaData}_`+keyMeta+'_date_'+z3"
                                    >
                                      <template
                                        v-if="(
                                        restriction = rr.restrictions.find((e) => e.appliedDate === appliedDate.date)) && 
                                        restriction.sellInventory !== null && 
                                        restriction.sellInventory >= 0"
                                      >
                                        <span>
                                          {{restriction.sellInventory}}
                                        </span>
                                      </template>
                                      <template v-else>
                                        <b>-</b>
                                      </template>
                                    </td>
                                  </tr>
                                  <tr
                                    v-else-if="
                                      metaData == 'priceExtraAdult' ||
                                      metaData == 'priceExtraChild' ||
                                      metaData == 'priceExtraBaby'
                                    "
                                    :key="'right_relationData_row6_'+i+ '_ratePlan_'+j1+'_roomRates_'+ir+`_${metaData}_`+keyMeta"
                                  >
                                  <td
                                    v-for="(appliedDate, z4) in dateList"
                                    :class="{ 'weekend-body': appliedDate.isWeekend }"
                                    class="border-right text-center"
                                    :key="'right_relationData_row4_'+i+ '_ratePlan_'+j1+'_roomRates_'+ir+`_${metaData}_`+keyMeta+'_date_'+z4"
                                    @mouseup="endSelectNotAllowed()"
                                  >
                                      <template
                                        v-if="
                                          rr['roomRateExtraSpecials'].length > 0 &&
                                          rr['roomRateExtraSpecials'].find(
                                            (x) =>
                                              x.appliedDate == appliedDate.date &&
                                              x.extraType ===
                                                (metaData == 'priceExtraAdult'
                                                  ? 0
                                                  : metaData == 'priceExtraChild'
                                                  ? 1
                                                  : 2)
                                          )
                                        "
                                      >
                                        <span class="px-2">
                                          {{
                                            priceExtraSpecialFormat(
                                              metaData,
                                              appliedDate.date,
                                              rr["roomRateExtraSpecials"]
                                            )
                                          }}
                                        </span>
                                        <span>
                                          <template
                                            v-if="
                                              tooltipPriceExtraSpecialFormat(
                                                metaData,
                                                appliedDate.date,
                                                rr['roomRateExtraSpecials']
                                              ) != ''
                                            "
                                          >
                                            <v-tooltip
                                              top
                                              transition="slide-y-reverse-transition"
                                            >
                                              <template v-slot:activator="{ on, attrs }">
                                                <i
                                                  class="icon-more fs-10 text-danger"
                                                  v-bind="attrs"
                                                  v-on="on"
                                                  style="position: relative; top: 2px"
                                                ></i>
                                              </template>
                                              <span
                                                v-html="
                                                  tooltipPriceExtraSpecialFormat(
                                                    metaData,
                                                    appliedDate.date,
                                                    rr['roomRateExtraSpecials']
                                                  )
                                                "
                                              ></span>
                                            </v-tooltip>
                                          </template>
                                        </span>
                                      </template>
                                      <template v-else>
                                        <span class="px-2">
                                          {{
                                            priceExtraFormat(
                                              metaData,
                                              appliedDate.date,
                                              rr.roomRateExtras
                                            )
                                          }}
                                        </span>
                                        <template
                                          v-if="
                                            tooltipPriceExtraFormat(
                                              metaData,
                                              appliedDate.date,
                                              rr.roomRateExtras
                                            ) != ''
                                          "
                                        >
                                          <v-tooltip
                                            top
                                            transition="slide-y-reverse-transition"
                                          >
                                            <template v-slot:activator="{ on, attrs }">
                                              <i
                                                class="icon-more fs-10"
                                                v-bind="attrs"
                                                v-on="on"
                                              ></i>
                                            </template>
                                            <span
                                              v-html="
                                                tooltipPriceExtraFormat(
                                                  metaData,
                                                  appliedDate.date,
                                                  rr.roomRateExtras
                                                )
                                              "
                                            ></span>
                                          </v-tooltip>
                                        </template>
                                      </template>
                                    </td>
                                  </tr>
                                  <tr v-else-if="metaData == 'pricePax'"
                                  :key="'right_relationData_row7_'+i+ '_ratePlan_'+j1+'_roomRates_'+ir+`_${metaData}_`+keyMeta"
                                  >
                                  <td
                                    v-for="(appliedDate, key) in dateList"
                                    :class="[
                                      { 'weekend-body': appliedDate.isWeekend },
                                      {'date-selected': 
                                        quickUpdate.dateMove.includes(appliedDate.date) && 
                                        quickUpdate.restriction == metaData &&
                                        room.id == quickUpdate.room.id &&
                                        ratePlan.id == quickUpdate.ratePlan.id &&
                                        rr.id == quickUpdate.roomRate.id},
                                      {'cursor': checkIsUpdate(room, ratePlan, rr, metaData)}
                                    ]"
                                    class="border-right text-center"
                                    @mousedown="startSelect(room,ratePlan, rr, appliedDate.date, metaData)"
                                    @mouseenter="continueSelect(room,ratePlan, rr, appliedDate.date, metaData)"
                                    @mouseup="endSelect(room, ratePlan, rr, appliedDate.date, metaData)"
                                    :key="'pricePax_dateList_'+key"
                                  >
                                      <span class="pr-2">
                                        {{
                                          priceExtraFormat(
                                            metaData,
                                            appliedDate.date,
                                            rr.roomRateExtras
                                          )
                                        }}
                                      </span>
                                      <template
                                        v-if="
                                          tooltipPriceExtraFormat(
                                            metaData,
                                            appliedDate.date,
                                            rr.roomRateExtras
                                          ) != ''
                                        "
                                      >
                                        <v-tooltip
                                          top
                                          transition="slide-y-reverse-transition"
                                        >
                                          <template v-slot:activator="{ on, attrs }">
                                            <v-icon
                                              class="mr-1"
                                              size="13"
                                              v-bind="attrs"
                                              v-on="on"
                                              >more</v-icon
                                            >
                                          </template>
                                          <span
                                            v-html="
                                              tooltipPriceExtraFormat(
                                                metaData,
                                                appliedDate.date,
                                                rr.roomRateExtras
                                              )
                                            "
                                          ></span>
                                        </v-tooltip>
                                      </template>
                                    </td>
                                  </tr>
                                </template>
                                <template v-else-if="rr.ota.otaCode === 'EZ_BE'">
                                  <tr
                                    v-if="
                                      metaData != 'priceExtraAdult' &&
                                      metaData != 'priceExtraChild' &&
                                      metaData != 'priceExtraBaby' &&
                                      metaData != 'pricePax' &&
                                      metaData != 'stopSell' &&
                                      metaData != 'sellLimit' &&
                                      metaData != 'sellInventory'
                                    "
                                    :key="'right_relationData_row4_'+i+ '_ratePlan_'+j1+'_roomRates_'+ir+`_${metaData}_`+keyMeta"
                                    >
                                    <td
                                    class="border-right text-center"
                                    v-for="(appliedDate, z2) in dateList"
                                    :class="[
                                      { 'weekend-body': appliedDate.isWeekend },
                                      {'date-selected': 
                                        quickUpdate.dateMove.includes(appliedDate.date) && 
                                        quickUpdate.restriction == metaData &&
                                        room.id == quickUpdate.room.id &&
                                        ratePlan.id == quickUpdate.ratePlan.id &&
                                        rr.id == quickUpdate.roomRate.id},
                                      {'cursor': checkIsUpdate(room, ratePlan, rr, metaData)}
                                    ]"
                                    @mousedown="startSelect(room,ratePlan, rr, appliedDate.date, metaData)"
                                    @mouseenter="continueSelect(room,ratePlan, rr, appliedDate.date, metaData)"
                                    @mouseup="endSelect(room, ratePlan, rr, appliedDate.date, metaData)"
                                    :key="'right_relationData_row4_'+i+ '_ratePlan_'+j1+'_roomRates_'+ir+`_${metaData}_`+keyMeta+'_date_'+z2"
                                    >
                                      <b v-if="
                                        !rr.restrictionsGroupBy[appliedDate.date] ||
                                        rr.restrictionsGroupBy[appliedDate.date][0][metaData] == null ||
                                        (
                                          rr.restrictionsGroupBy[appliedDate.date] &&
                                          rr.restrictionsGroupBy[appliedDate.date][0][metaData] === -1
                                        )"
                                      >-</b>
                                      <template v-else>
                                        <template
                                          v-if="
                                            (metaData == 'closed' ||
                                              metaData == 'closedOnArrival' ||
                                              metaData == 'closedOnDeparture') &&
                                            rr.restrictionsGroupBy[appliedDate.date][0][
                                              metaData
                                            ] === true
                                          "
                                        >
                                          <i
                                            class="icon-Exit text-danger fs-18 font-weight-bold"
                                          ></i>
                                        </template>

                                        <template
                                          v-else-if="
                                            (metaData == 'closed' ||
                                              metaData == 'closedOnArrival' ||
                                              metaData == 'closedOnDeparture') &&
                                            rr.restrictionsGroupBy[appliedDate.date][0][
                                              metaData
                                            ] === false
                                          "
                                        >
                                          <i
                                            class="icon-check text-success fs-16 font-weight-bold"
                                          ></i>
                                        </template>
                                        <template v-else>
                                          {{ rr.restrictionsGroupBy[appliedDate.date][0][metaData]
                                          +''+
                                          (rr.restrictionsGroupBy[appliedDate.date][0][metaData] !== -1 && (metaData.endsWith("ByHour")) ? 'H' : metaData.endsWith("Window") ? 'D' : '') }}
                                        </template>
                                      </template>
                                    </td>
                                  </tr>
                                  <tr 
                                v-else-if="metaData == 'stopSell'"
                                :key="'right_relationData_row5_'+i+ '_ratePlan_'+j1+'_roomRates_'+ir+`_${metaData}_`+keyMeta"
                                >
                                  <td
                                    class="border-right text-center"
                                    v-for="(appliedDate, z3) in dateList"
                                    :class="[
                                      { 'weekend-body': appliedDate.isWeekend },
                                      {'date-selected': 
                                        quickUpdate.dateMove.includes(appliedDate.date) && 
                                        quickUpdate.restriction == metaData &&
                                        room.id == quickUpdate.room.id &&
                                        ratePlan.id == quickUpdate.ratePlan.id &&
                                        rr.id == quickUpdate.roomRate.id},
                                      {'cursor': checkIsUpdate(room, ratePlan, rr, metaData)}
                                    ]"
                                    @mousedown="startSelect(room,ratePlan, rr, appliedDate.date, metaData)"
                                    @mouseenter="continueSelect(room,ratePlan, rr, appliedDate.date, metaData)"
                                    @mouseup="endSelect(room, ratePlan, rr, appliedDate.date, metaData)"
                                    :key="'right_relationData_row4_'+i+ '_ratePlan_'+j1+'_roomRates_'+ir+`_${metaData}_`+keyMeta+'_date_'+z3"
                                  >
                                    <template
                                      v-if="(
                                      restriction = rr.restrictions.find((e) => e.appliedDate === appliedDate.date)) &&
                                      restriction.stopLimit !== null && 
                                      restriction.stopLimit >= 0"
                                    >
                                      <span>
                                        {{ restriction.stopLimit }}
                                      </span>
                                    </template>
                                    <template v-else>
                                      <b>-</b>
                                    </template>
                                  </td>
                                </tr>
                                <tr 
                                  v-else-if="metaData == 'sellLimit'"
                                  :key="'right_relationData_row5+_'+i+ '_ratePlan_'+j1+'_roomRates_'+ir+`_${metaData}_`+keyMeta"
                                >
                                  <td
                                    class="border-right text-center"
                                    v-for="(appliedDate, z3) in dateList"
                                    :class="[
                                      { 'weekend-body': appliedDate.isWeekend },
                                      {'date-selected': 
                                        quickUpdate.dateMove.includes(appliedDate.date) && 
                                        quickUpdate.restriction == metaData &&
                                        room.id == quickUpdate.room.id &&
                                        ratePlan.id == quickUpdate.ratePlan.id &&
                                        rr.id == quickUpdate.roomRate.id},
                                      {'cursor': checkIsUpdate(room, ratePlan, rr, metaData)}
                                    ]"
                                    @mousedown="startSelect(room,ratePlan, rr, appliedDate.date, metaData)"
                                    @mouseenter="continueSelect(room,ratePlan, rr, appliedDate.date, metaData)"
                                    @mouseup="endSelect(room, ratePlan, rr, appliedDate.date, metaData)"
                                    :key="'right_relationData_row4+_'+i+ '_ratePlan_'+j1+'_roomRates_'+ir+`_${metaData}_`+keyMeta+'_date_'+z3"
                                  > 
                                    <template
                                      v-if="(
                                      restriction = rr.restrictions.find((e) => e.appliedDate === appliedDate.date)) &&
                                      restriction.sellLimit !== null && 
                                      restriction.sellLimit >= 0"
                                    >
                                      <span>
                                        {{
                                          restriction.sellLimit
                                        }}
                                      </span>
                                    </template>
                                    <template v-else>
                                      <b>-</b>
                                    </template>
                                  </td>
                                </tr>
                                <tr 
                                  v-else-if="metaData == 'sellInventory'"
                                  :key="'right_relationData_row6+_'+i+ '_ratePlan_'+j1+'_roomRates_'+ir+`_${metaData}_`+keyMeta"
                                >
                                  <td
                                    class="border-right text-center"
                                    v-for="(appliedDate, z3) in dateList"
                                    :class="{ 'weekend-body': appliedDate.isWeekend }"
                                    :key="'right_relationData_row4_'+i+ '_ratePlan_'+j1+'_roomRates_'+ir+`_${metaData}_`+keyMeta+'_date_'+z3"
                                  >
                                    <template
                                      v-if="(
                                      restriction = rr.restrictions.find((e) => e.appliedDate === appliedDate.date)) && 
                                      restriction.sellInventory !== null && 
                                      restriction.sellInventory >= 0"
                                    >
                                      <span>
                                        {{restriction.sellInventory}}
                                      </span>
                                    </template>
                                    <template v-else>
                                      <b>-</b>
                                    </template>
                                  </td>
                                </tr>
                                <tr
                                  v-else-if="
                                    metaData == 'priceExtraAdult' ||
                                    metaData == 'priceExtraChild' ||
                                    metaData == 'priceExtraBaby'
                                  "
                                  :key="'right_relationData_row6_'+i+ '_ratePlan_'+j1+'_roomRates_'+ir+`_${metaData}_`+keyMeta"
                                >
                                  <td
                                    v-for="(appliedDate, z4) in dateList"
                                    :class="{ 'weekend-body': appliedDate.isWeekend }"
                                    class="border-right text-center"
                                    :key="'right_relationData_row4_'+i+ '_ratePlan_'+j1+'_roomRates_'+ir+`_${metaData}_`+keyMeta+'_date_'+z4"
                                    @mouseup="endSelectNotAllowed()"
                                  >
                                      <template
                                        v-if="
                                          rr['roomRateExtraSpecials'].length > 0 &&
                                          rr['roomRateExtraSpecials'].find(
                                            (x) =>
                                              x.appliedDate == appliedDate.date &&
                                              x.extraType ===
                                                (metaData == 'priceExtraAdult'
                                                  ? 0
                                                  : metaData == 'priceExtraChild'
                                                  ? 1
                                                  : 2)
                                          )
                                        "
                                      >
                                        <span class="px-2">
                                          {{
                                            priceExtraSpecialFormat(
                                              metaData,
                                              appliedDate.date,
                                              rr["roomRateExtraSpecials"]
                                            )
                                          }}
                                        </span>
                                        <span>
                                          <template
                                            v-if="
                                              tooltipPriceExtraSpecialFormat(
                                                metaData,
                                                appliedDate.date,
                                                rr['roomRateExtraSpecials']
                                              ) != ''
                                            "
                                          >
                                            <v-tooltip
                                              top
                                              transition="slide-y-reverse-transition"
                                            >
                                              <template v-slot:activator="{ on, attrs }">
                                                <i
                                                  class="icon-more fs-10 text-danger"
                                                  v-bind="attrs"
                                                  v-on="on"
                                                  style="position: relative; top: 2px"
                                                ></i>
                                              </template>
                                              <span
                                                v-html="
                                                  tooltipPriceExtraSpecialFormat(
                                                    metaData,
                                                    appliedDate.date,
                                                    rr['roomRateExtraSpecials']
                                                  )
                                                "
                                              ></span>
                                            </v-tooltip>
                                          </template>
                                        </span>
                                      </template>
                                      <template v-else>
                                        <span class="px-2">
                                          {{
                                            priceExtraFormat(
                                              metaData,
                                              appliedDate.date,
                                              rr.roomRateExtras
                                            )
                                          }}
                                        </span>
                                        <template
                                          v-if="
                                            tooltipPriceExtraFormat(
                                              metaData,
                                              appliedDate.date,
                                              rr.roomRateExtras
                                            ) != ''
                                          "
                                        >
                                          <v-tooltip
                                            top
                                            transition="slide-y-reverse-transition"
                                          >
                                            <template v-slot:activator="{ on, attrs }">
                                              <i
                                                class="icon-more fs-10"
                                                v-bind="attrs"
                                                v-on="on"
                                              ></i>
                                            </template>
                                            <span
                                              v-html="
                                                tooltipPriceExtraFormat(
                                                  metaData,
                                                  appliedDate.date,
                                                  rr.roomRateExtras
                                                )
                                              "
                                            ></span>
                                          </v-tooltip>
                                        </template>
                                      </template>
                                    </td>
                                  </tr>
                                  <tr 
                                  v-else-if="metaData == 'pricePax'"
                                  :key="'right_relationData_row7_'+i+ '_ratePlan_'+j1+'_roomRates_'+ir+`_${metaData}_`+keyMeta"
                                  >
                                  <td
                                    v-for="(appliedDate, key) in dateList"
                                    :class="[
                                      { 'weekend-body': appliedDate.isWeekend },
                                      {'date-selected': 
                                        quickUpdate.dateMove.includes(appliedDate.date) && 
                                        quickUpdate.restriction == metaData &&
                                        room.id == quickUpdate.room.id &&
                                        ratePlan.id == quickUpdate.ratePlan.id &&
                                        rr.id == quickUpdate.roomRate.id},
                                      {'cursor': checkIsUpdate(room, ratePlan, rr, metaData)}
                                    ]"
                                    class="border-right text-center"
                                    @mousedown="startSelect(room,ratePlan, rr, appliedDate.date, metaData)"
                                    @mouseenter="continueSelect(room,ratePlan, rr, appliedDate.date, metaData)"
                                    @mouseup="endSelect(room, ratePlan, rr, appliedDate.date, metaData)"
                                    :key="'pricePax_dateList_'+key"
                                  >
                                      <span class="pr-2">
                                        {{
                                          priceExtraFormat(
                                            metaData,
                                            appliedDate.date,
                                            rr.roomRateExtras
                                          )
                                        }}
                                      </span>
                                      <template
                                        v-if="
                                          tooltipPriceExtraFormat(
                                            metaData,
                                            appliedDate.date,
                                            rr.roomRateExtras
                                          ) != ''
                                        "
                                      >
                                        <v-tooltip
                                          top
                                          transition="slide-y-reverse-transition"
                                        >
                                          <template v-slot:activator="{ on, attrs }">
                                            <v-icon
                                              class="mr-1"
                                              size="13"
                                              v-bind="attrs"
                                              v-on="on"
                                              >more</v-icon
                                            >
                                          </template>
                                          <span
                                            v-html="
                                              tooltipPriceExtraFormat(
                                                metaData,
                                                appliedDate.date,
                                                rr.roomRateExtras
                                              )
                                            "
                                          ></span>
                                        </v-tooltip>
                                      </template>
                                    </td>
                                  </tr>
                                </template>
                              </template>
                            </template>
                          </template>
                        </template>
                      </template>
                    </tbody>
                  </table>
                </td>
              </tr>
            </table>
            <div v-if="loadingMore" class="text-center py-2" style="position:sticky; left: 0;">
              <v-progress-circular
                :width="2"
                color="gray"
                indeterminate
              ></v-progress-circular>
            </div>
            <v-btn
              v-if="!isNote"
              color="primary"
              dark
              bottom
              left
              class="btn-note"
              @click="
                isNote = true;
                maxHeight = maxHeight - 60;
              "
            >
              <i class="icon-category fs-16"></i>
            </v-btn>
          </div>
          <div class="text-center" v-if="isLoading">
            <img src="@/assets/loading-logo-animation.gif" style="width: 75px" />

            <p class="font-weight-bold">{{ $t("THE_SYSTEM_IS_LOADING") }}</p>
          </div>
          <v-col
            class="border-top d-flex align-items-center"
            v-if="isNote"
            style="position: absolute; bottom: 0; background: #fff; z-index: 8"
          >
            <ul class="tools-icon-description">
              <li>
                <i class="icon-hive fs-16 text-primary"></i>
                {{ $t("COMBO") }}
              </li>
              <li>
                <i class="icon-edit-ic text-primary fs-16"></i>
                {{ $t("EDIT") }}
              </li>
              <li>
                <i class="icon-delete fs-16 text-danger"></i>
                {{ $t("DELETE") }}
              </li>
              <li>
                <i class="icon-cloud_done fs-16 text-primary"></i>
                {{ $t("CONNECTED") }}
              </li>
              <li>
                <i class="icon-cloud_upload text-warning fs-16"></i>
                {{ $t("CONNECTING") }}
              </li>

              <li>
                <span class="font-weight-bold">000</span>
                {{ $t("DAILY_PRICE") }}
              </li>
              <li>
                <span class="text-smart font-weight-bold">000</span>
                {{ $t("DYNAMIC_PRICING") }}
              </li>
              <li>
                <span class="text-master-rate">000</span>
                {{ $t("MASTER_RATE") }}
              </li>
              <li>
                <span class="text-master-rate font-weight-bold">000</span>
                {{ $t("DAILY_MASTER_RATE") }}
              </li>
              <li>
                <span class="i-square">
                  <i class="close-before"></i>
                </span>
                {{ $t("closedOnArrival") }}
              </li>
              <li>
                <span class="i-square">
                  <i class="close-after"></i>
                </span>
                {{ $t("closedOnDeparture") }}
              </li>
              <li>
                <span class="i-square bg-stopSell"></span>
                {{ $t("closed") }}
              </li>
              <li>
                <span class="txt-child">D</span>
                {{ $t("ROOM_DERIVE") }}
              </li>
              <li>
                <span class="txt-child-primary">C</span>
                {{ $t("DERIVED_ROOMTYPE") }}
              </li>
            </ul>
            <v-btn
              class="ml-3 py-5"
              dark
              small
              color="primary"
              @click="
                isNote = false;
                maxHeight = maxHeight + 60;
              "
            >
              <i class="icon-expand_more fs-16"></i>
            </v-btn>
          </v-col>
        </template>

        <!-- popup cap nhat gia theo ngay -->

        <v-dialog v-model="dialogUpdateRate" :max-width="380" v-if="isLoading == false">
          <v-toolbar class="toolbar-update" dense>
            <v-toolbar-title class="text-primary fs-15">
              <strong>{{
                $t("UPDATE_FOR", {
                  date: _moment(new Date(dateUpdate)).format("DD/MM/YYYY"),
                })
              }}</strong>
            </v-toolbar-title>
          </v-toolbar>
          <div class="content-update">
            <p class="mb-0" v-if="roomRateUpdate">
              <label class="s-label"
                ><span class="font-weight-bold">{{ $t("BOOKING_CHANNEL") }}:</span>
                {{
                  roomRateUpdate.ota.otaI18n.find((x) => x.lang == defaultI18n).name
                }}</label
              >
            </p>
            <p class="mb-0" v-if="roomUpdate">
              <label class="s-label"
                ><span class="font-weight-bold"
                  >{{ $t("_ROOM_SALE.ROOM_TYPE.ROOM_TYPE") }}:</span
                >
                {{
                  roomUpdate.roomTypeI18n.find((x) => x.lang == defaultI18n).name
                }}</label
              >
            </p>
            <p class="mb-0" v-if="rateUpdate">
              <label class="s-label"
                ><span class="font-weight-bold"
                  >{{ $t("_SALE_PACKAGE.SALE_PACKAGE") }}:</span
                >
                {{ rateUpdate.i18ns.find((x) => x.lang == defaultI18n).name }}</label
              >
            </p>
            <label class="s-label"
              ><span class="font-weight-bold">{{ $t("SERVICE.PRICE") }}</span></label
            >
            <vuetify-number
              :options="usedCurrency == 'VND' ? priceOptionsVi : priceOptionsEn"
              dense
              outlined
              v-model="priceUpdate"
            />
            <div class="mt-3 d-flex justify-content-between">
              <div class="mr-auto" v-if="dialogUpdateRate">
                <v-btn
                  v-if="checkSpecialPrice(rateUpdate, dateUpdate)"
                  block
                  color="error"
                  @click="
                    $refs.deleteSpecialPriceDialogComponent.open({
                      roomTypeId: roomUpdate.id,
                      ratePlanId: rateUpdate.id,
                      date: dateUpdate,
                    })
                  "
                >
                  {{ $t("REMOVE_SPECIAL_PRICE") }}
                </v-btn>
              </div>
              <div class="mr-1">
                <v-btn depressed block @click="dialogUpdateRate = false">
                  {{ $t("_LOGIN.CANCEL") }}
                </v-btn>
              </div>
              <div class="ml-1">
                <v-btn
                  class=""
                  block
                  color="primary"
                  @click="confirmUpdateSpecialPrice()"
                >
                  {{ $t("UPDATE") }}
                </v-btn>
              </div>
            </div>
          </div>
        </v-dialog>

        <v-dialog
          v-model="dialogUpdateRoomPrice"
          :max-width="380"
          v-if="isLoading == false"
        >
          <v-toolbar class="toolbar-update" dense>
            <v-toolbar-title class="text-primary fs-15">
              <strong>{{
                $t("UPDATE_FOR", {
                  date: _moment(new Date(dateUpdate)).format("DD/MM/YYYY"),
                })
              }}</strong>
            </v-toolbar-title>
          </v-toolbar>
          <div class="content-update">
            <p class="mb-0" v-if="roomUpdate">
              <label class="s-label"
                ><span class="font-weight-bold"
                  >{{ $t("_ROOM_SALE.ROOM_TYPE.ROOM_TYPE") }}:</span
                >
                {{
                  roomUpdate.roomTypeI18n.find((x) => x.lang == defaultI18n).name
                }}</label
              >
            </p>
            <label class="s-label"
              ><span class="font-weight-bold">{{ $t("HOTEL_ROOM_RATE") }}</span></label
            >
            <vuetify-number
              :options="usedCurrency == 'VND' ? priceOptionsVi : priceOptionsEn"
              dense
              outlined
              v-model="priceUpdate"
            />
            <div class="mt-3 d-flex justify-content-end">
              <div class="mr-1 w-100">
                <v-btn depressed block @click="dialogUpdateRoomPrice = false">
                  {{ $t("_LOGIN.CANCEL") }}
                </v-btn>
              </div>
              <div class="ml-1 w-100">
                <v-btn
                  class=""
                  block
                  color="primary"
                  @click="confirmUpdateSpecialPriceRoom()"
                >
                  {{ $t("UPDATE") }}
                </v-btn>
              </div>
            </div>
          </div>
        </v-dialog>

        <!-- popup cap nhat phong theo ngay -->

        <v-dialog v-model="dialogUpdateAvai" :max-width="325" v-if="isLoading == false">
          <v-toolbar class="toolbar-update" dense>
            <v-toolbar-title class="text-primary fs-15">
              <strong>{{
                $t("UPDATE_FOR", {
                  date: _moment(new Date(dateUpdate)).format("DD/MM/YYYY"),
                })
              }}</strong>
            </v-toolbar-title>
          </v-toolbar>
          <div class="content-update">
            <p class="mb-0" v-if="roomUpdate">
              <label class="s-label"
                ><span class="font-weight-bold"
                  >{{ $t("_ROOM_SALE.ROOM_TYPE.ROOM_TYPE") }}:</span
                >
                {{
                  roomUpdate.roomTypeI18n.find((x) => x.lang == defaultI18n).name
                }}</label
              >
            </p>
            <label class="s-label"
              ><span class="font-weight-bold">{{
                $t("_BOOKING_DETAIL.ROOM.QUANTITY")
              }}</span></label
            >
            <v-text-field
              onkeyup="this.value=this.value.replace(/[^\d]/,'')"
              outlined
              dense
              v-model="roomAvai"
              type="number"
            ></v-text-field>
            <div class="mt-3 d-flex justify-content-between">
              <div class="w-100 mr-1">
                <v-btn depressed block @click="dialogUpdateAvai = false">
                  {{ $t("_LOGIN.CANCEL") }}
                </v-btn>
              </div>
              <div class="w-100 ml-1">
                <v-btn class="" block color="primary" @click="confirmUpdateRoomAvail()">
                  {{ $t("UPDATE") }}
                </v-btn>
              </div>
            </div>
          </div>
        </v-dialog>

        <!-- popup cap nhat ngung ban theo ngay -->

        <v-dialog
          v-model="dialogUpdateStopSell"
          :max-width="325"
          v-if="isLoading == false"
        >
          <v-toolbar class="toolbar-update" dense>
            <v-toolbar-title class="text-primary fs-15">
              <strong>{{
                $t("UPDATE_FOR", {
                  date: _moment(new Date(dateUpdate)).format("DD/MM/YYYY"),
                })
              }}</strong>
            </v-toolbar-title>
          </v-toolbar>
          <div class="content-update">
            <label class="s-label font-weight-bold">{{
              $t(isUpdateStopSell ? "CONFIRM_REMOVE_STOP_SELL" : "CONFIRM_STOP_SELL")
            }}</label>
            <p class="mb-0" v-if="roomUpdate">
              <label class="s-label"
                ><span class="font-weight-bold">{{ $t("BOOKING_CHANNEL") }}:</span>
                {{ listOTA.find((e) => e.value === selectedOTA).text }}</label
              >
            </p>
            <p class="mb-0" v-if="roomUpdate">
              <label class="s-label"
                ><span class="font-weight-bold"
                  >{{ $t("_ROOM_SALE.ROOM_TYPE.ROOM_TYPE") }}:</span
                >
                {{
                  roomUpdate.roomTypeI18n.find((x) => x.lang == defaultI18n).name
                }}</label
              >
            </p>
            <p class="mb-0" v-if="rateUpdate">
              <label class="s-label"
                ><span class="font-weight-bold"
                  >{{ $t("_SALE_PACKAGE.SALE_PACKAGE") }}:</span
                >
                {{ rateUpdate.i18ns.find((x) => x.lang == defaultI18n).name }}</label
              >
            </p>
            <div class="mt-3 d-flex justify-content-between">
              <div class="w-100 mr-1">
                <v-btn depressed block @click="dialogUpdateStopSell = false">
                  {{ $t("_LOGIN.CANCEL") }}
                </v-btn>
              </div>
              <div class="w-100 ml-1">
                <v-btn
                  v-if="!isUpdateStopSell"
                  block
                  color="warning"
                  @click="confirmUpdateRestriction(true)"
                >
                  {{ $t("STOP_SELL") }}
                </v-btn>
                <v-btn
                  v-if="isUpdateStopSell"
                  block
                  color="primary"
                  @click="confirmUpdateRestriction(false)"
                >
                  {{ $t("UN_STOP_SELL") }}
                </v-btn>
              </div>
            </div>
          </div>
        </v-dialog>

        <!-- Popup xac nhan xoa goi ban -->
        <delete-dialog
          @deleteItem="removeSalePackage"
          :maxWidth="325"
          ref="deleteDialogComponent"
        >
          <span slot="title">{{ $t("CONFIRM_DELETE_SALE_PACKAGE") }}?</span>
        </delete-dialog>

        <!-- Popup xac nhan xoa gia dac biet-->
        <delete-dialog
          @deleteItem="delSpecialPrice"
          :maxWidth="325"
          ref="deleteSpecialPriceDialogComponent"
        >
          <span slot="title">{{ $t("CONFIRM_DELETE_SPECIAL_PRICE") }}?</span>
        </delete-dialog>

        <!-- Popup xac nhan xoa gia dac biet phu thu nguoi lon-->
        <delete-dialog
          @deleteItem="removeSpecialPriceExtraAdult"
          :maxWidth="325"
          ref="deleteSpecialPriceExtraAdultDialogComponent"
        >
          <span slot="title">{{ $t("CONFIRM_DELETE_SPECIAL_PRICE_EXTRA_ADULT") }}?</span>
        </delete-dialog>

        <!-- Popup xac nhan xoa gia dac biet phu thu tre em-->
        <delete-dialog
          @deleteItem="removeSpecialPriceExtraChild"
          :maxWidth="325"
          ref="deleteSpecialPriceExtraChildDialogComponent"
        >
          <span slot="title">{{ $t("CONFIRM_DELETE_SPECIAL_PRICE_EXTRA_CHILD") }}?</span>
        </delete-dialog>

        <!-- Popup xac nhan xoa gia dac biet phu thu em be-->
        <delete-dialog
          @deleteItem="removeSpecialPriceExtraBaby"
          :maxWidth="325"
          ref="deleteSpecialPriceExtraBabyDialogComponent"
        >
          <span slot="title">{{ $t("CONFIRM_DELETE_SPECIAL_PRICE_EXTRA_BABY") }}?</span>
        </delete-dialog>

        <!-- Popup chọn gói bán -->
        <v-dialog
          v-if="isLoading == false"
          v-model="popupSalePackage.addSalePackageDialog"
          width="750"
          class="modal-quick-edit"
        >
          <loading
            :active.sync="popupSalePackage.isLoading"
            :is-full-page="false"
          ></loading>
          <v-toolbar class="toolbar-update" dense>
            <v-toolbar-title class="text-primary fs-15">
              <strong>
                {{ $t("ADD_SALE_PACKAGE") }} -
                {{ listOTA.find((x) => x.value == selectedOTA).text }}</strong
              >
            </v-toolbar-title>
          </v-toolbar>
          <div class="content-update">
            <v-row>
              <template v-if="popupSalePackage.listSalePackage.length > 0">
                <v-col
                  md="6"
                  class="pb-0"
                  v-for="item in popupSalePackage.listSalePackage"
                  :key="item.text"
                >
                  <v-checkbox
                    v-model="popupSalePackage.selectedSalePackage"
                    :label="item.text"
                    :value="item.value"
                    class="p-0 m-0"
                  ></v-checkbox>
                </v-col>
              </template>
              <template v-else>
                <v-col md="12" class="text-center" style="color: red">{{
                  $t("NO_SALEPACKAGE_AVAIL")
                }}</v-col>
              </template>
            </v-row>
            <div class="mt-4 d-flex justify-content-between">
              <div class="w-100 mr-1">
                <v-btn
                  depressed
                  block
                  @click="popupSalePackage.addSalePackageDialog = false"
                >
                  {{ $t("_LOGIN.CANCEL") }}
                </v-btn>
              </div>
              <div class="w-100 ml-1">
                <v-btn block color="primary" @click="confirmSalePackage()">
                  {{ $t("ADD_SALE_PACKAGE") }}
                </v-btn>
              </div>
            </div>
          </div>
        </v-dialog>
      </div>
    </div>
    
    <!-- popup cập nhật nhanh -->
    <v-dialog v-model="quickUpdateDialog" width="450">
      <div class="bg-white">
        <div class="px-3" style="background: #e0e6f2; font-size: 14px;">
          <v-container class="px-0">
            <div class="text-primary font-weight-bold">{{$t('FAST_UPDATE')}}</div>
          </v-container>
        </div>
        <!-- kênh bán -->
        <v-row class="m-0 pt-1" v-if="!['inventory', 'HOTEL_ROOM_RATE'].includes(quickUpdate.restriction)">
          <v-col class="py-0 font-weight-bold d-flex align-center" cols="3">
            {{$t('SALE_CHANNEL')}}
          </v-col>
          <v-col class="py-0 pl-0 line-limit" cols="9" :title="quickUpdate.roomSale.ota.i18n">
            {{quickUpdate.roomSale.ota.i18n}}
          </v-col>
        </v-row>
        <!-- tên loại phòng -->
        <v-row class="m-0 pt-1">
          <v-col class="py-0 font-weight-bold d-flex align-center" cols="3">
            {{$t('HOTEL_LOG_roomTypeI18n')}}
          </v-col>
          <v-col class="py-0 pl-0" cols="9" :title="quickUpdate.roomSale.room.i18n">
              {{quickUpdate.roomSale.room.i18n}}
          </v-col>
        </v-row>
        <!-- chính sách giá -->
        <v-row class="m-0 pt-1" v-if="!['inventory', 'HOTEL_ROOM_RATE'].includes(quickUpdate.restriction)">
          <v-col class="py-0 font-weight-bold d-flex align-center" cols="3">
            {{$t('HOTEL_LOG_ratePlanI18n')}}
          </v-col>
          <v-col class="py-0 pl-0 line-limit" cols="9" :title="quickUpdate.roomSale.ratePlan.i18n">
            {{quickUpdate.roomSale.ratePlan.i18n}}
          </v-col>
        </v-row>
        <!-- cập nhật -->
        <v-row class="m-0 pt-1">
          <v-col class="py-0 font-weight-bold d-flex align-center" cols="3">
            {{$t('QUICK_UPDATE')}}
          </v-col>
          <v-col class="py-0 pl-0" cols="9">
            <v-autocomplete 
            dense 
            outlined 
            item-text="text" 
            item-value="value"
            :items="getAllRestriction"
            v-model="quickUpdate.restriction"
            @change="changeRestriction()"
            >
              <template v-slot:selection="{ item}">
                <span class="text-primary font-weight-bold">{{ item.text }}</span>
              </template>
              <template slot="no-data">
                <div class="no-data">{{ $t("NO_DATA") }}</div>
              </template>
            </v-autocomplete>
          </v-col>
        </v-row>
        <!-- khoảng ngày -->
        <v-row class="m-0 py-1">
          <v-col class="py-0 font-weight-bold d-flex align-center" cols="3">
            {{$t('DATE_RANGE')}}
          </v-col>
          <v-col class="py-0 pl-0" cols="9">
            <vue2-date-picker 
              :confirm-text="$t('CONFIRM')" 
              :clearable="false" 
              :format="'DD/MM/YYYY'"
              :type="'date'"
              :popup-class="'popup-calendar-desktop-detailhotel'" 
              v-model="dateRange" 
              :lang="languageDate"
              :editable="false" 
              range
              :disabled-date="disableDate"
              placeholder="Select date range"
              class="w-100 date-picker-input"
              @change="getMaxValue(true)"
            ></vue2-date-picker>
          </v-col>
        </v-row>
        <!-- số lượng phòng -->
        <v-row class="m-0" v-if="['inventory', 'stopSell', 'sellLimit'].includes(quickUpdate.restriction)">
          <v-col v-if="quickUpdate.restriction == 'inventory'" class="py-0 font-weight-bold d-flex align-center text-nowrap" cols="3">
            {{$t('_REQUEST_DETAIL.ROOM.QUANTITY')}}
          </v-col>
          <v-col v-else class="py-0 font-weight-bold d-flex align-center text-nowrap" cols="3">
            {{$t('_REGISTER.NUMBER_OF_ROOMS')}}
          </v-col>
          <v-col class="py-0 pl-0" cols="9">
            <v-text-field
              v-model="quantity"
              outlined 
              dense
              onkeyup="this.value=this.value.replace(/[^\d]/g,'')"
              @blur="validateQuantity($event.target.value, quickUpdate)"
            ></v-text-field>
          </v-col>
        </v-row>
        <!-- giá -->
        <v-row class="m-0" v-if="['price', 'HOTEL_ROOM_RATE'].includes(quickUpdate.restriction)">
          <v-col class="py-0 font-weight-bold d-flex align-center" cols="3">
            {{$t('PRICE')}}
          </v-col>
          <v-col class="py-0 pl-0" cols="9">
            <v-text-field
              :error="quickUpdate.errors.hasError"
              :error-messages="quickUpdate.errors.errorMessage"
              :class="{'protection-rate-error': quickUpdate.errors.hasError}"
              v-model="price"
              outlined
              dense
              @keydown="keyCurrencyDown($event, usedCurrency)"
              :prefix="prefixCurrency"
              :suffix="suffixCurrency"
              :key="`quickUpdatePrice_${forceRenderKey}`"
              ref="quickUpdatePrice"
            ></v-text-field>
          </v-col>
        </v-row>
          <!-- số ngày / gio -->
        <v-row class="m-0" v-if="!['price', 'HOTEL_ROOM_RATE', 'closedOnArrival','closedOnDeparture','inventory','closed', 'stopSell', 'sellLimit'].includes(quickUpdate.restriction)">
          <v-col class="py-0 font-weight-bold d-flex align-center" cols="3">
            <span v-if="[
            'minBookingWindowByHour',
            'maxBookingWindowByHour'
            ].includes(quickUpdate.restriction)">
              {{$t('NUMBER_OF_HOURS')}}
            </span>
            <span v-else>{{$t('NUMBER_OF_DAYS')}}</span>
          </v-col>
          <v-col class="py-0 pl-0" cols="9">
            <v-text-field
              v-model="quantity"
              outlined
              dense
              onkeyup="this.value=this.value.replace(/[^\d]/g,'')"
              @blur="validateQuantity($event.target.value, quickUpdate)"
              :suffix="[
            'minBookingWindowByHour',
            'maxBookingWindowByHour'
            ].includes(quickUpdate.restriction) ? 'H': ''"
            ></v-text-field>
          </v-col>
        </v-row>
        
        <!-- huy / update -->
        <v-row class="m-0" v-if="!['price', 'closedOnArrival', 'closedOnDeparture','closed'].includes(quickUpdate.restriction)">
          <v-col class="pr-1" cols="6">
            <v-btn
              class="w-100"
              color="#e0e6f2"
              @click="quickUpdateDialog = false"
            >
              {{$t('SERVICE.CANCEL')}}
            </v-btn>
          </v-col>
          <v-col class="pl-1" cols="6">
            <v-btn
              color="primary"
              class="w-100"
              :disabled="isUpdate"
              @click="saveRestriction()"
            >
              {{$t('UPDATE')}}
            </v-btn>
          </v-col>
        </v-row>
        <!--xoa gia ngay / huy / update -->
        <v-row class="m-0" v-if="['price'].includes(quickUpdate.restriction)">
          <v-col class="pr-1" :cols="quickUpdate.priceType == priceType.PRICE_OF_DAY ? '4' : '6'">
            <v-btn
              class="w-100"
              color="#e0e6f2"
              @click="quickUpdateDialog = false"
            >
              {{$t('SERVICE.CANCEL')}}
            </v-btn>
          </v-col>
          <v-col class="px-1" cols="4" v-if="quickUpdate.priceType == priceType.PRICE_OF_DAY">
            <v-btn
              class="w-100"
              color="#FFD17B"
              @click="delSpecialPriceConfirm()"
              :disabled="isUpdate"
            >
              {{$t('REMOVE_DAYLY_RATE')}}
            </v-btn>
          </v-col>
          <v-col class="pl-1" :cols="quickUpdate.priceType == priceType.PRICE_OF_DAY ? '4' : '6'">
            <v-btn
              color="primary"
              class="w-100"
              :disabled="isUpdate"
              @click="saveRestriction()"
            >
              {{$t('UPDATE')}}
            </v-btn>
          </v-col>
        </v-row>
        <!-- huy / ngung ban / mo ban -->
        <v-row class="m-0" v-if="['closed'].includes(quickUpdate.restriction)">
          <v-col class="pr-1" cols="4">
            <v-btn
              class="w-100"
              color="#e0e6f2"
              @click="quickUpdateDialog = false"
            >
              {{$t('SERVICE.CANCEL')}}
            </v-btn>
          </v-col>
          <v-col class="px-1" cols="4">
            <v-btn
              class="w-100"
              color="#FFD17B"
              :disabled="isUpdate"
              @click="() => {quickUpdate.selected = true; saveRestriction()}"
            >
              {{$t('STOP_SELL')}}
            </v-btn>
          </v-col>
          <v-col class="pl-1" cols="4">
            <v-btn
              color="primary"
              class="w-100"
              :disabled="isUpdate"
              @click="() => {quickUpdate.selected = false; saveRestriction()}"
            >
              {{$t('UN_STOP_SELL')}}
            </v-btn>
          </v-col>
        </v-row>
        <!-- huy / khong cho check in / cho check in -->
        <v-row class="m-0" v-if="['closedOnArrival'].includes(quickUpdate.restriction)">
          <v-col class="pr-1" cols="4">
            <v-btn
              class="w-100"
              color="#e0e6f2"
              @click="quickUpdateDialog = false"
            >
              {{$t('SERVICE.CANCEL')}}
            </v-btn>
          </v-col>
          <v-col cols="4" class="px-1">
            <v-btn
              class="w-100"
              color="#FFD17B"
              :disabled="isUpdate"
              @click="() => {quickUpdate.selected = true; saveRestriction()}"
            >
              {{$t('closedOnArrival')}}
            </v-btn>
          </v-col>
          <v-col class="pl-1" cols="4">
            <v-btn
              color="primary"
              class="w-100"
              :disabled="isUpdate"
              @click="() => {quickUpdate.selected = false; saveRestriction()}"
            >
              {{$t('ALLOW_CHECKIN')}}
            </v-btn>
          </v-col>
        </v-row>
        <!-- huy / khong cho check out / cho check out -->
        <v-row class="m-0" v-if="['closedOnDeparture'].includes(quickUpdate.restriction)">
          <v-col cols="4" class="pr-1">
            <v-btn
              class="w-100"
              color="#e0e6f2"
              @click="quickUpdateDialog = false"
            >
              {{$t('SERVICE.CANCEL')}}
            </v-btn>
          </v-col>
          <v-col cols="4" class="px-1">
            <v-btn
              class="w-100"
              color="#FFD17B"
              :disabled="isUpdate"
              @click="() => {quickUpdate.selected = true; saveRestriction()}"
            >
              {{$t('closedOnDeparture')}}
            </v-btn>
          </v-col>
          <v-col cols="4" class="pl-1">
            <v-btn
              color="primary"
              class="w-100"
              :disabled="isUpdate"
              @click="() => {quickUpdate.selected = false; saveRestriction()}"
            >
              {{$t('ALLOW_CHECKOUT')}}
            </v-btn>
          </v-col>
        </v-row>
      </div>
    </v-dialog>
    <v-dialog v-model="priceInvalidDialog" width="325">
      <v-toolbar class="toolbar-update" dense >
        <v-toolbar-title class="text-primary fs-15">
          <strong>{{$t('NOTIFICATION')}}</strong>
        </v-toolbar-title>
      </v-toolbar>
      <div class="content-update">
        <label class="s-label">
          {{$t('BASE_PRICE_REQUIRED')}}
        </label>
        <div class="mt-3 d-flex justify-content-end">
          <v-btn 
            color="#e0e6f2" 
            @click="priceInvalidDialog = false"
          >
            {{ $t("CLOSE") }}
          </v-btn>
        </div>
      </div>
    </v-dialog>
  </div>
</template>

<style lang="scss" scoped>
.special-price + div {
  display: none;
}

.add-person {
  padding-left: 10px;
  z-index: 99999999;
}

.delete-person {
  padding-left: 10px;
  z-index: 99999999;
}

.copy-price {
  left: -8px;
  top: 8px;
  position: absolute;
  z-index: 99999999;
}

.tab-header {
  background-color: #fff;
  padding: 25px 15px 10px 15px;
}

.restriction-ota {
  font-size: 14px;

  h6 {
    font-size: 14px;

    &.room-title {
      background: #f0f0f0;
      padding: 10px;
      margin: 0;
      border-radius: 5px;
    }
  }

  .sale-package-info {
    align-items: center;
    border-bottom: 1px solid #dedddd;
    padding-bottom: 5px;
  }

  .col-md-12:last-child {
    .sale-package-info {
      border-bottom: none;
    }
  }
}
</style>

<script>
import { _alert } from "@/_helpers/function.js";
import { sale_room } from "@/_services/SaleRoom/sale-room.js";
import { service } from "@/_services/SaleRoom/room-plan.service.js";
import { salePackageService } from "@/_services/SaleRoom/sale-package.service.js";

import "vue-ctk-date-time-picker/dist/vue-ctk-date-time-picker.css";

import { syncota } from "@/_services/SyncOTA/syncota.js";

import moment from "moment";
import { categoryService } from "@/_services/SaleRoom/category.service.js";

import Treeselect from "@riophae/vue-treeselect";
// import the styles
import "@riophae/vue-treeselect/dist/vue-treeselect.css";
import Vue2DatePicker from 'vue2-datepicker';
import 'vue2-datepicker/index.css';
import { restriction } from "@/_services/SaleRoom/restriction.js";

export default {
  components: {
    "delete-dialog": () => import("@/components/Utils/DeleteDialog.vue"),
    "date-picker": () => import("@/components/Utils/DatePicker.vue"),
    Treeselect,
    "vue2-date-picker": Vue2DatePicker
  },
  data() {
    return {
      isNote: true,
      syncPMS: JSON.parse(localStorage.getItem("currentUser")).hotel.syncPMS,
      syncInventory: JSON.parse(localStorage.getItem("currentUser")).hotel.syncInventory,
      maxHeight: 407,
      weekend: ["WED", "THU", "FRI", "SAT", "SUN", "TUE", "MON"],
      defaultWeekend: [],
      dateList: [],
      isLoading: true,
      systemLang: this.$i18n.locale,
      currentDatePicker: moment().startOf("day").format("YYYY-MM-DD"),
      selectedRoom: [], // Phòng đang được sửa
      selectedRoomCalendar: -1,
      listRoom: [], // Danh sách các phòng, do dữ liệu roomData cấu thành list
      relationData: [], // Thông tin gói bán và giá của tất cả phòng do API trả về
      currentDate: moment().startOf("day").toDate(),
      maxDate: moment(this.currentDate)
        .add(2, "year")
        .add(14, "day")
        .format("YYYY-MM-DD"),
        listMetaData: [
        {
          text: this.$t("ROOM_FOR_SALE"),
          value: "sellInventory",
          sortInx: 1
        },
        {
          text: this.$t("HOTEL_ROOM_RATE"),
          value: "HOTEL_ROOM_RATE",
          sortInx: 2
        },
        {
          text: this.$t("priceExtraAdult"),
          value: "priceExtraAdult",
          sortInx: 3
        },
        {
          text: this.$t("priceExtraChild"),
          value: "priceExtraChild",
          sortInx: 4
        },
        {
          text: this.$t("priceExtraBaby"),
          value: "priceExtraBaby",
          sortInx: 5
        },
        {
          text: this.$t("minStay"),
          value: "minStay",
          sortInx: 6
        },
        {
          text: this.$t("maxStay"),
          value: "maxStay",
          sortInx: 7
        },
        {
          text: this.$t("minStayArrival"),
          value: "minStayArrival",
          sortInx: 8
        },
        {
          text: this.$t("maxStayArrival"),
          value: "maxStayArrival",
          sortInx: 9
        },
        {
          text: this.$t("minBookingWindow"),
          value: "minBookingWindow",
          sortInx: 10
        },
        {
          text: this.$t("maxBookingWindow"),
          value: "maxBookingWindow",
          sortInx: 11
        },
        {
          text: this.$t("minBookingWindowByHour"),
          value: "minBookingWindowByHour",
          sortInx: 12
        },
        {
          text: this.$t("maxBookingWindowByHour"),
          value: "maxBookingWindowByHour",
          sortInx: 13
        },
        {
          text: this.$t("exactStay"),
          value: "exactStay",
          sortInx: 14
        },
        {
          text: this.$t("exactStayArrival"),
          value: "exactStayArrival",
          sortInx: 15
        },
        {
          text: this.$t("closedOnArrival"),
          value: "closedOnArrival",
          sortInx: 16
        },
        {
          text: this.$t("closedOnDeparture"),
          value: "closedOnDeparture",
          sortInx: 17
        },
        {
          text: this.$t("closed"),
          value: "closed",
          sortInx: 18
        },
        {
          text: this.$t("STOP_SELL_LIMIT"),
          value: "stopSell",
          sortInx: 19
        },
        {
          text: this.$t("SELL_LIMIT"),
          value: "sellLimit",
          sortInx: 20
        }
      ],
      listOTA: [],
      selectedOTA: null,
      selectedMetaData: localStorage.getItem("currentFilterRoomSale")
        ? JSON.parse(localStorage.getItem("currentFilterRoomSale"))
        : ["closed"],
      selectedDatePicker: '',
      popupSalePackage: {
        addSalePackageDialog: false,
        listSalePackageDefault: [],
        listSalePackage: [],
        selectedSalePackage: [],
        roomTypeId: null,
        isLoading: false,
      },
      view: "table", // Calendar
      calendarCurrentMonthYear: moment().startOf("day").format("YYYY-MM"),
      calendarCurrentSalePackage: "-1",
      calendarRate: null,
      calendarListSalePackage: [],
      currentYear: new Date().getFullYear(),
      tableSelect: "PRICE",
      optionTableSelect: [
        {
          text: this.$t("_BATCH_UPDATE.PRICE"),
          value: "PRICE",
        },
        {
          text: this.$t("_BATCH_UPDATE.AVAILABLE_ROOM"),
          value: "AVAILABLE_ROOM",
        },
      ],
      dialogUpdateRate: false,
      dialogUpdateRoomPrice: false,
      priceUpdate: 0,
      idUpdateRate: null,
      roomAvai: 0,
      dialogUpdateAvai: false,
      roomIdUpdate: null,
      dialogUpdateStopSell: false,
      isUpdateStopSell: true,
      idUpdateStopsell: null,
      roomUpdate: null,
      rateUpdate: null,
      metas: ["closed"],
      dateUpdate: null,
      weekend: [],
      selectedSalePackage: [],
      menu: false,
      listRateCategory: [],
      selectedRateCategory: [],
      listRatePlanByRateCategory: [],
      changeSelect: false,
      isOpen: false,
      listRoomTypeByRoomCategory: [],
      listRoomCategory: [],
      otaCodeEdit: null,
      roomRateUpdate: null,
      oldRalation: [],
      quickUpdate: {
        filterDate: false,
        dateMove: [],
        roomSale: {
          roomRate: {
            id: null
          },
          room: {
            id: null,
            i18n: null
          },
          ratePlan: {
            id: null,
            i18n: null
          },
          ota: {
            id: null,
            groupId: null,
            i18n: null
          },
          restrictionPlanId: ''
        },
        room: {},
        ratePlan: {},
        roomRate: {},
        startDate: null,
        endDate: null,
        restriction: null,
        quantity: 0,
        dateRange:[],
        price: 0,
        selected: false, //true la khong, false la co
        priceType: 0,  //kiểu giá 0 ngày 1 tuần
        dateList: [],
        maxValue: {
          inventory: 0, //phòng trống
          price: 0, //gía bán
          minStay: 0, //ngay o toi thieu
          maxStay: 0, // ngày ở tối đa
          minStayArrival: 0, //ngay o toi thieu theo ngay den
          maxStayArrival: 0, // ngay o toi da theo ngay den
          minBookingWindow: 0,//ngay dat truoc toi thieu
          maxBookingWindow: 0,//ngay dat truoc toi da
          minBookingWindowByHour: 0, //gio dat truoc toi thieu
          maxBookingWindowByHour: 0, //gio dat truoc toi da
          exactStay: 0, //ngay o chinh xac
          exactStayArrival: 0, //ngay o chinh xac theo ngay den
          closedOnArrival: 0, //khong cho check-in
          closedOnDeparture: 0, //khong cho check-out
          closed: 0, //ngừng bán
          HOTEL_ROOM_RATE: 0, //giá phòng
          stopSell: 0,
          sellLimit: 0
        },
        errors: {
          hasError: false,
          errorMessage: null
        }
      },
      priceType: {
        PRICE_OF_DAY: 0,
        PRICE_OF_WEEK: 1
      },
      quickUpdateDialog: false,
      isUpdate: false,
      priceInvalidDialog: false,
      isScrolling: false,
      scrollSpeed: 10,
      scrollInterval: null,
      mouseDownPos: null,
      listOTAGroup: [],
      perPage: 0,
      totalPage: 0,
      tmpRelationData: [],
      loadingMore: false,
      itemsPerPage: 15,
      quantityRequest: 15,
      controller: null,
      loadingRelation: false,
      waitingLoadMore: false,
      relationRequestId: 0,
      loadMoreTimer: null,
      timeout: null,
      forceRenderKey: 0,
    };
  },
  computed: {
    daysOfMonths() {
      return [31, this.isLeapYear() ? 29 : 28, 31, 30, 31, 30, 31, 31, 30, 31, 30, 31];
    },
    getAllRestriction() {
      let data = [{
        text: this.$t("ROOM_AVAIL"),
        value: "inventory"
      },
      {
        text: this.$t("SERVICE.PRICE"),
        value: "price"
      }];
      data = [...data, ...this.listMetaData.filter((e) => !['priceExtraAdult', 'priceExtraChild', 'priceExtraBaby', 'sellInventory'].includes(e.value))];
      let onlyRoom = ['inventory','HOTEL_ROOM_RATE'];
      if(onlyRoom.includes(this.quickUpdate.restriction)) {
        return data.filter((e) => onlyRoom.includes(e.value));
      }
      return data.filter((e) => !onlyRoom.includes(e.value));
    },
    quantity: {
      get() {
        return this.quickUpdate.quantity;
      },
      set(val) {
        this.quickUpdate.quantity = val;
      }
    },
    price: {
      get() {
        return this.convertDecimalViaLocal(this.quickUpdate.price);
      },
      set(val) {
        clearTimeout(this.timeout);
        this.timeout = setTimeout(() => {
          const value = this.setCurrency(val);
          this.quickUpdate.price = value;
          if (this.quickUpdate.price == value) {
            this.forceRenderKey++;
            this.$nextTick(() => {
              if (this.$refs.quickUpdatePrice) {
                this.$refs.quickUpdatePrice.focus();
              }
            });
          }
        }, this.timeOutChange(val));
      }
    },
    dateRange: {
      get() {
        return this.quickUpdate.dateRange;
      },
      set(val) {
        this.quickUpdate.dateRange = val;
      }
    }
  },
  created() {
    this.maxHeight = window.innerHeight - 50 - 68 - 46 - 70 - 60 + 15 - 24;
    this.initialize(false);
    
    let meta = localStorage.getItem("currentFilterRoomSale")
      ? JSON.parse(localStorage.getItem("currentFilterRoomSale"))
      : ["closed"];
    meta = this.sortMetas(meta);
    this.metas = meta.filter((e) => e !== "HOTEL_ROOM_RATE");
  },
  watch: {
    quickUpdateDialog() {
      if(this.quickUpdateDialog == false) {
        this.resetQuickUpdate();
      }
    },
    currentYear() {
      this.getRateCalendar(false);
    },
    selectedDatePicker() {
      this.currentDate = this.selectedDatePicker;
      this.changeDate();
    },
    calendarCurrentMonthYear() {
      this.getRateCalendar(false);
    },
    selectedSalePackage() {
      if (this.selectedSalePackage.length === 0 && this.isOpen === false) {
        clearTimeout(this.timeout);
        this.timeout = setTimeout(() => {
          this.changeSearchCondition(true);
        }, 1000);
        this.changeSelect = false;
      } else {
        this.changeSelect = true;
      }
    },
    selectedRoom() {
      if (this.selectedRoom.length === 0 && this.isOpen === false) {
        clearTimeout(this.timeout);
        this.timeout = setTimeout(() => {
          this.changeSearchCondition(true);
        }, 1000);
        this.changeSelect = false;
      } else {
        this.changeSelect = true;
      }
    },
  },
  mounted() {
    window.addEventListener("resize", this.onResize);
    this.getRestrictionPlanId();
    this.getAllOTAGroup();
  },
  methods: {
    checkProtectionRate() {
      if(['price', 'HOTEL_ROOM_RATE'].includes(this.quickUpdate.restriction)) {
        this.quickUpdate.errors.hasError = false;
        this.quickUpdate.errors.errorMessage = null;
        const priceMin = this.quickUpdate.room.priceMin;
        const priceMax = this.quickUpdate.room.priceMax;
        const price = this.quickUpdate.price;
        if (priceMin != null && priceMax != null && (parseFloat(price) < parseFloat(priceMin) || parseFloat(price) > parseFloat(priceMax))) {
          this.quickUpdate.errors.hasError = true;
          this.quickUpdate.errors.errorMessage = this.$t("SAFE_PRICE_RANGE.PROTECTION_RATE_INPUT_INVALID", {priceMax: this.formatCurrencyWithSymbol(priceMax), priceMin: this.formatCurrencyWithSymbol(priceMin)});
        }

        if (priceMin != null && !priceMax && parseFloat(price) < parseFloat(priceMin)) {
          this.quickUpdate.errors.hasError = true;
          this.quickUpdate.errors.errorMessage = this.$t("SAFE_PRICE_RANGE.MINIMUM_RATE_INPUT_INVALID", {priceMin: this.formatCurrencyWithSymbol(priceMin)});
        }

        if (!priceMin && priceMax != null && parseFloat(price) > parseFloat(priceMax)) {
          this.quickUpdate.errors.hasError = true;
          this.quickUpdate.errors.errorMessage = this.$t("SAFE_PRICE_RANGE.MAXIMUM_RATE_INPUT_INVALID", {priceMax: this.formatCurrencyWithSymbol(priceMax)});
        }
        return this.quickUpdate.errors.hasError == false;
      }
      return true;
    },
    startScrolling(event) {
      this.isScrolling = true;
      this.mouseDownPos = { x: event.clientX, y: event.clientY };
      this.scrollDirection = { x: 0, y: 0 };
      this.continueScrolling();
    },
    handleMouseMove(event) {
      if (!this.isScrolling) return;

      const element = this.$refs.scrollableDiv;
      const rect = element.getBoundingClientRect();
      const mouseX = event.clientX - rect.left;
      const mouseY = event.clientY - rect.top;

      const thresholdLeft = 520;
      const thresholdTop = 100;
      const thresholdBottom = 50;
      const thresholdRight = 50;
      if (mouseX > rect.width - thresholdRight && element.scrollLeft < element.scrollWidth - rect.width) {
        this.scrollDirection.x = 1;
      } else if (mouseX < thresholdLeft && element.scrollLeft > 0) {
        this.scrollDirection.x = -1; 
      }
      if (mouseY > rect.height - thresholdBottom && element.scrollTop < element.scrollHeight - rect.height) {
        this.scrollDirection.y = 1;
      } else if (mouseY < thresholdTop && element.scrollTop > 0) {
        this.scrollDirection.y = -1; 
      }
    },
    continueScrolling() {
      if (!this.isScrolling) return;
      const element = this.$refs.scrollableDiv;
      if (this.scrollDirection.x !== 0) {
        this.scrollHorizontally(element);
      }
      
      if (this.scrollDirection.y !== 0) {
        this.scrollVertically(element);
      }
      requestAnimationFrame(this.continueScrolling);
    },
    scrollHorizontally(element) {
      element.scrollLeft += this.scrollSpeed * this.scrollDirection.x;
    },
    scrollVertically(element) {
      element.scrollTop += this.scrollSpeed * this.scrollDirection.y;
    },
    stopScrolling() {
      this.isScrolling = false;
      this.scrollDirection = { x: 0, y: 0 };
      this.mouseDownPos = null;
    },
    disableDate(date) {
      const today = moment().startOf("day"); 
      const maxDate = moment(today).add(1, "year"); 
      const checkingDate = moment(date);
      return checkingDate.isBefore(today) || checkingDate.isAfter(maxDate);
    },
    startSelect(room, ratePlans, roomRate, startDate, restriction) {
      if(this.checkIsUpdate(room,ratePlans, roomRate, restriction) == false) {
        return;
      }
      this.quickUpdate.dateMove = [];
      this.quickUpdate.startDate = startDate;
      this.quickUpdate.filterDate = true;
      this.quickUpdate.dateMove.push(startDate);
      this.quickUpdate.restriction = restriction;
      this.quickUpdate.room = room;
      this.quickUpdate.ratePlan = ratePlans || {};
      this.quickUpdate.roomRate = roomRate || {};
    },
    continueSelect(room, ratePlans, roomRate, continueDate, restriction) {
      if (!this.quickUpdate.filterDate) {
        return;
      }
      this.quickUpdate.restriction = restriction;
      this.quickUpdate.room = room;
      this.quickUpdate.ratePlan = ratePlans || {};
      this.quickUpdate.roomRate = roomRate || {};
      this.quickUpdate.dateMove = this.filterDatesWithinRange(this.quickUpdate.startDate, continueDate);
    },
    filterDatesWithinRange(startDate, endDate) {
      let [start, end] = [startDate, endDate].sort((a, b) => new Date(a) - new Date(b));
      const data = [];
      const currentDate = moment(start);
      const endDateMoment = moment(end);

      while (currentDate.isSameOrBefore(endDateMoment)) {
        data.push(currentDate.format("YYYY-MM-DD"));
        currentDate.add(1, "days");
      }

      return data;
    },
    checkMouseLeave() {
      if (!this.quickUpdate.filterDate) {
        return;
      }
      const room = this.quickUpdate.room;
      const ratePlan = this.quickUpdate.ratePlan;
      const roomRate = this.quickUpdate.roomRate;
      const restriciton = this.quickUpdate.restriction;
      const startDate = this.quickUpdate.startDate;
      const lastDateMove = this.quickUpdate.dateMove[this.quickUpdate.dateMove.length -1];
      let endDate = lastDateMove;
      if (startDate == lastDateMove) {
        endDate = this.quickUpdate.dateMove[0];
      }
      this.endSelect(room, ratePlan, roomRate, endDate, restriciton);
    },
    endSelectNotAllowed() {
      if (!this.quickUpdate.filterDate) {
        return;
      }
      this.resetQuickUpdate();
    },
    async endSelect(room, ratePlans, roomRate, endDate, restriction) {
      if(this.checkIsUpdate(room, ratePlans, roomRate, restriction) == false) {
        this.resetQuickUpdate();
        return;
      }
      if (!endDate) {
        this.resetQuickUpdate();
        return;
      }
      this.quickUpdate.room = room;
      this.quickUpdate.ratePlan = ratePlans || {};
      this.quickUpdate.roomRate = roomRate || {};
      this.quickUpdate.filterDate = false;
      this.quickUpdate.endDate = endDate;
      this.quickUpdate.restriction = restriction;
      this.quickUpdate.roomSale.room.id = room.id;
      this.quickUpdate.roomSale.room.i18n = room.roomTypeI18n.find(x => x.lang == this.defaultI18n).name || '';;
      this.quickUpdate.roomSale.ratePlan.id = ratePlans ? ratePlans.id : null;
      this.quickUpdate.roomSale.ratePlan.i18n = ratePlans && ratePlans.i18ns ? ratePlans.i18ns.find(x => x.lang == this.defaultI18n).name || '' : '';
      this.quickUpdate.roomSale.ota.id = roomRate && roomRate.ota ? roomRate.ota.id : null;
      this.quickUpdate.roomSale.ota.i18n = roomRate && roomRate.ota ? roomRate.ota.otaI18n.find(x => x.lang == this.defaultI18n).name || '' : '';
      this.quickUpdate.roomSale.roomRate.id = roomRate ? roomRate.id : null;

      if (['sellLimit', 'stopSell'].includes(restriction)) {
        let ratePlansName = '';
        if (this.selectedSalePackage.length > 0 && this.selectedSalePackage[0] == '-1') {
          ratePlansName = room.ratePlans.map((ratePlan) => ratePlan.i18ns.find(y => y.lang == this.defaultI18n).name).join(', ') || '';
        } else {
          const body = {
            roomIds: [room.id],
            year: new Date(this.selectedDatePicker).getFullYear(),
            month: null,
            ota: this.quickUpdate.roomSale.ota.id
          };
          const data = await this.getRoomRate(body);
          const findRoom = data.find(e => e.id == room.id) || null;
          if (findRoom && findRoom.ratePlans.length > 0) {
            ratePlansName = findRoom.ratePlans.map((ratePlan) => ratePlan.i18ns.find(y => y.lang == this.defaultI18n).name).join(', ') || '';
          }
        }
        this.quickUpdate.roomSale.ratePlan.i18n = ratePlansName;
        if (restriction == 'sellLimit') {
          let otaName = '';
          for (const item of this.listOTAGroup) {
            if (item.otas.some(ota => ota.id == this.quickUpdate.roomSale.ota.id)) {
              this.quickUpdate.roomSale.ota.groupId = item.value;
              otaName = item.otas.map((ota) => ota.otaI18n.find(y => y.lang == this.defaultI18n).name).join(', ') || '';
            }
          }
          this.quickUpdate.roomSale.ota.i18n = otaName;
        }
      }

      //lấy ngày bắt đầu và kết thúc.
      this.quickUpdate.restriction = restriction;
      this.quickUpdate.endDate = moment(endDate, "YYYY-MM-DD").toDate();
      //nếu không có ngày bắt đầu thì sẽ chỉ update ở ngày cuối cùng
      if(!this.quickUpdate.startDate) {
        this.quickUpdate.startDate = endDate;
      }
      this.quickUpdate.startDate = moment(this.quickUpdate.startDate, "YYYY-MM-DD").toDate();
      
      let start = this.quickUpdate.startDate;
      let end = this.quickUpdate.endDate;
      if (start > end) {
        const temp = start;
        start = end;
        end = temp;
      }
      this.quickUpdate.dateRange = [start, end];
      if(restriction == 'price') {
        let isValid = this.validateBasePrice(this.quickUpdate.roomRate, this.quickUpdate.startDate, this.quickUpdate.endDate);
        if (isValid == false) {
          this.priceInvalidDialog = true;
          this.resetQuickUpdate();
          return
        }
      }
      this.getMaxValue();
      this.quickUpdateDialog = true;
    },
    async changeRestriction() {
      let restriction = this.quickUpdate.restriction;
      let maxValue = JSON.parse(JSON.stringify(this.quickUpdate.maxValue));
      
      if(restriction == 'price') {
        let isValid = this.validateBasePrice(this.quickUpdate.roomRate, this.quickUpdate.startDate, this.quickUpdate.endDate);
        if (isValid == false) {
          this.priceInvalidDialog = true;
        }
      }
      const ratePlans = this.quickUpdate.ratePlan;
      const roomRate = this.quickUpdate.roomRate;
      if (['sellLimit', 'stopSell'].includes(restriction)) {
        this.quickUpdate.roomSale.ota.i18n = roomRate && roomRate.ota ? roomRate.ota.otaI18n.find(x => x.lang == this.defaultI18n).name : '';
        const room = this.quickUpdate.room;
        let ratePlansName = '';
        if (this.selectedSalePackage.length > 0 && this.selectedSalePackage[0] == '-1') {
          ratePlansName = room.ratePlans.map((ratePlan) => ratePlan.i18ns.find(y => y.lang == this.defaultI18n).name).join(', ') || '';
        } else {
          const body = {
            roomIds: [room.id],
            year: new Date(this.selectedDatePicker).getFullYear(),
            month: null,
            ota: this.quickUpdate.roomSale.ota.id
          };
          const data = await this.getRoomRate(body);
          const findRoom = data.find(e => e.id == room.id) || null;
          if (findRoom && findRoom.ratePlans.length > 0) {
            ratePlansName = findRoom.ratePlans.map((ratePlan) => ratePlan.i18ns.find(y => y.lang == this.defaultI18n).name).join(', ') || '';
          }
        }
        this.quickUpdate.roomSale.ratePlan.i18n = ratePlansName;
        if (restriction == 'sellLimit') {
          let otaName = '';
          for (const item of this.listOTAGroup) {
            if (item.otas.some(ota => ota.id == this.quickUpdate.roomSale.ota.id)) {
              this.quickUpdate.roomSale.ota.groupId = item.value;
              otaName = item.otas.map((ota) => ota.otaI18n.find(y => y.lang == this.defaultI18n).name).join(', ') || '';
            }
          }
          this.quickUpdate.roomSale.ota.i18n = otaName;
        }
      } else {
        this.quickUpdate.roomSale.ratePlan.i18n = ratePlans && ratePlans.i18ns ? ratePlans.i18ns.find(x => x.lang == this.defaultI18n).name : '';
        this.quickUpdate.roomSale.ota.i18n = roomRate && roomRate.ota ? roomRate.ota.otaI18n.find(x => x.lang == this.defaultI18n).name : '';
      }

      const mapping = {
        inventory: "inventory",
        minStay: "minStay",
        maxStay: "maxStay",
        minStayArrival: "minStayArrival",
        maxStayArrival: "maxStayArrival",
        minBookingWindow: "minBookingWindow",
        maxBookingWindow: "maxBookingWindow",
        minBookingWindowByHour: "minBookingWindowByHour",
        maxBookingWindowByHour: "maxBookingWindowByHour",
        exactStay: "exactStay",
        exactStayArrival: "exactStayArrival",
        price: "price",
        HOTEL_ROOM_RATE: "HOTEL_ROOM_RATE",
        stopSell: "stopSell",
        sellLimit: "sellLimit"
      };
      if (restriction in mapping) {
        let key = mapping[restriction];
        if (["price", "HOTEL_ROOM_RATE"].includes(key)) {
          this.quickUpdate.price = maxValue[key] >= 0 ? maxValue[key] : 0;
        } else {
          this.quickUpdate.quantity = maxValue[key] >= 0 ? maxValue[key] : 0;
        }
      }
    },
    resetQuickUpdate() {
      this.quickUpdate.filterDate = false;
      this.quickUpdate.roomSale.roomRate.id = null;
      this.quickUpdate.roomSale.room.id = null;
      this.quickUpdate.roomSale.room.i18n = null;
      this.quickUpdate.roomSale.ratePlan.id = null;
      this.quickUpdate.roomSale.ratePlan.i18n = null;
      this.quickUpdate.roomSale.ota.id = null;
      this.quickUpdate.roomSale.ota.groupId = null;
      this.quickUpdate.roomSale.ota.i18n = null;
      this.quickUpdate.startDate = null;
      this.quickUpdate.endDate = null;
      this.quickUpdate.restriction = null;
      this.quickUpdate.quantity = 0;
      this.quickUpdate.dateRange = [];
      this.quickUpdate.dateList = [];
      this.quickUpdate.price = 0;
      this.quickUpdate.selected = false;
      this.quickUpdate.maxValue.inventory = 0;
      this.quickUpdate.maxValue.HOTEL_ROOM_RATE = 0;
      this.quickUpdate.maxValue.priceOfDay = 0;
      this.quickUpdate.maxValue.priceOfWeek = 0;
      this.quickUpdate.maxValue.minStay = 0;
      this.quickUpdate.maxValue.maxStay = 0;
      this.quickUpdate.maxValue.minStayArrival = 0;
      this.quickUpdate.maxValue.maxStayArrival = 0;
      this.quickUpdate.maxValue.minBookingWindow = 0;
      this.quickUpdate.maxValue.maxBookingWindow = 0;
      this.quickUpdate.maxValue.minBookingWindowByHour = 0;
      this.quickUpdate.maxValue.maxBookingWindowByHour = 0;
      this.quickUpdate.maxValue.exactStay = 0;
      this.quickUpdate.maxValue.exactStayArrival = 0;
      this.quickUpdate.maxValue.closedOnArrival = 0;
      this.quickUpdate.maxValue.closedOnDeparture = 0;
      this.quickUpdate.maxValue.closed = 0;
      this.quickUpdate.maxValue.stopSell = 0;
      this.quickUpdate.maxValue.sellLimit = 0;
      this.quickUpdate.room = {};
      this.quickUpdate.ratePlan = {};
      this.quickUpdate.roomRate = {};
      this.quickUpdate.dateMove = [];
      this.quickUpdate.errors.hasError = false;
      this.quickUpdate.errors.errorMessage = null;
    },
    getMaxValue(isChangeDate = false) {
      let room = this.quickUpdate.room;
      let ratePlan = this.quickUpdate.ratePlan;
      let roomRate = this.quickUpdate.roomRate;
      let startDate = this.quickUpdate.dateRange[0];
      let endDate = this.quickUpdate.dateRange[1];
      let maxValue = {
        inventory: -1,
        HOTEL_ROOM_RATE: -1,
        price: -1,
        minStay: -1,
        maxStay: -1,
        minStayArrival: -1,
        maxStayArrival: -1,
        minBookingWindow: -1,
        maxBookingWindow: -1,
        minBookingWindowByHour: -1,
        maxBookingWindowByHour: -1,
        exactStay: -1,
        exactStayArrival: -1,
        closedOnArrival: false,
        closedOnDeparture: false,
        closed: false,
        priceOfDay: -1,
        priceOfWeek: -1,
        stopSell: -1,
        sellLimit: -1
      };

      let currentDate = moment(startDate, "YYYY-MM-DD");
      const endDateMoment = moment(endDate, "YYYY-MM-DD");
      this.quickUpdate.dateList = [];
      let isSetupPriceOfDay = false;
      this.quickUpdate.dateMove = [];
      let checkOnlyPriceDay = {
        isValid: true,
        maxValue: 0
      };
      while (currentDate.isSameOrBefore(endDateMoment)) {
        const currentDateString = currentDate.format("YYYY-MM-DD");
        let date = {};
        date.applyDate = currentDateString;
        date.id = null;
        this.quickUpdate.dateMove.push(currentDateString);
        if(!isChangeDate) {
          if (['inventory','HOTEL_ROOM_RATE'].includes(this.quickUpdate.restriction)) {
            if (
              room.availByDate[currentDateString] &&
              room.availByDate[currentDateString][0]
            ) {
              maxValue.inventory = Math.max(
                maxValue.inventory,
                room.availByDate[currentDateString][0].quantity || -1
              );
            }

            if (
              room.roomTypeSpecials.length > 0 &&
              room.roomTypeSpecials.filter((x) => x.appliedDate === currentDateString).length >
                0 &&
              room.roomTypeSpecials.find((x) => x.appliedDate === currentDateString).pricePax !=
                -1
            ) {
              maxValue.HOTEL_ROOM_RATE = Math.max(maxValue.HOTEL_ROOM_RATE,
              room.roomTypeSpecials.find((x) => x.appliedDate === currentDateString).pricePax);
            } else {
              let isWeekend = this.dateList.find((x) => x.date == currentDateString).isWeekend;
              maxValue.HOTEL_ROOM_RATE = Math.max(maxValue.HOTEL_ROOM_RATE,
              isWeekend ? room.weekendPrice : room.defaultPrice);
            }
          } else {
            if (roomRate && roomRate['roomRateSpecials']) {
              const getRoomRateSpecials = roomRate['roomRateSpecials'].find((z) => z.appliedDate == currentDateString) || null;
              let specialPrice = this.checkSpecialPrice(roomRate, currentDateString);
              let priceOfDay = -1;
              let priceOfWeek = -1;
              
              if (specialPrice) {
                priceOfDay = roomRate["roomRateSpecials"].find((x) => x.appliedDate == currentDateString).pricePax;
                if (priceOfDay > 0) {
                  isSetupPriceOfDay = true;
                  date.id = getRoomRateSpecials != null ? getRoomRateSpecials.id : null;
                  checkOnlyPriceDay.maxValue = Math.max(checkOnlyPriceDay.maxValue, priceOfDay);
                } else {
                  checkOnlyPriceDay.isValid = false;
                }
              } else {
                checkOnlyPriceDay.isValid = false;
              }
              priceOfWeek = roomRate[this.formatDateOfWeekInPrice(currentDateString)];
              if(priceOfWeek == -1) {
                isSetupPriceOfWeek = false;
              }
              maxValue.price = Math.max(maxValue.price, Math.max(priceOfDay, priceOfWeek));
              let ratePlanRestrictions = roomRate.restrictionsGroupBy[currentDateString][0];
              maxValue.minStay = Math.max(maxValue.minStay, ratePlanRestrictions.minStay);
              maxValue.maxStay = Math.max(maxValue.maxStay, ratePlanRestrictions.maxStay);
              maxValue.minStayArrival = Math.max(maxValue.minStayArrival, ratePlanRestrictions.minStayArrival);
              maxValue.maxStayArrival = Math.max(maxValue.maxStayArrival, ratePlanRestrictions.maxStayArrival);
              maxValue.minBookingWindow = Math.max(maxValue.minBookingWindow, ratePlanRestrictions.minBookingWindow);
              maxValue.maxBookingWindow = Math.max(maxValue.maxBookingWindow, ratePlanRestrictions.maxBookingWindow);
              maxValue.minBookingWindowByHour = Math.max(maxValue.minBookingWindowByHour, ratePlanRestrictions.minBookingWindowByHour);
              maxValue.maxBookingWindowByHour = Math.max(maxValue.maxBookingWindowByHour, ratePlanRestrictions.maxBookingWindowByHour);
              maxValue.exactStay = Math.max(maxValue.exactStay, ratePlanRestrictions.exactStay);
              maxValue.exactStayArrival = Math.max(maxValue.exactStayArrival, ratePlanRestrictions.exactStayArrival);
              maxValue.sellLimit = Math.max(maxValue.sellLimit, ratePlanRestrictions.sellLimit);
              maxValue.stopSell = Math.max(maxValue.stopSell, ratePlanRestrictions.stopLimit);
            }
          }
        }
        this.quickUpdate.dateList.push(date);
        currentDate.add(1, "days");
      }
      if (checkOnlyPriceDay.isValid) {
        maxValue.price = checkOnlyPriceDay.maxValue;
      }
      this.quickUpdate.priceType = isSetupPriceOfDay == true 
        ? this.priceType.PRICE_OF_DAY 
        : this.priceType.PRICE_OF_WEEK;

      this.quickUpdate.maxValue = maxValue;
      this.changeRestriction();
    },
    checkUpdated(roomId, ratePlanIds, roomRateId, fromDate, toDate, restriction, value, roomRoot = null) {
      const room = roomRoot != null ? roomRoot : this.relationData.find(e => e.id === roomId);
      if (!room) return false;
      const dates = [];
      const currentFromDate = moment(this.selectedDatePicker, "YYYY-MM-DD");
      const currentToDate = moment(this.selectedDatePicker, "YYYY-MM-DD")
        .add(30, "day")
        .format("YYYY-MM-DD");
      let start = moment(fromDate, "YYYY-MM-DD");
      let end = moment(toDate, "YYYY-MM-DD");

      if (start.isBefore(currentFromDate)) {
        start = currentFromDate;
      }

      if (end.isAfter(currentToDate)) {
        end = currentToDate;
      }

      while (start.isSameOrBefore(end)) {
        dates.push(start.format("YYYY-MM-DD"));
        start = start.add(1, "day");
      }
      const checkCondition = (currentDateString) => {
        if (['inventory', 'HOTEL_ROOM_RATE'].includes(restriction)) {
          if (restriction === 'inventory') {
            const res = room.availByDate &&
                  room.availByDate[currentDateString] &&
                  room.availByDate[currentDateString][0] &&
                  room.availByDate[currentDateString][0].quantity;
            return res == value;
          }
          if (restriction === 'HOTEL_ROOM_RATE') {
            const res = this.checkSpecialPriceRoom(room, currentDateString);
            return res == value;
          }
        } else {
          const isValid = ratePlanIds.some(id => {
            const ratePlan = room.ratePlans.find(e => e.id === id);
            if (!ratePlan) return false;

            const roomRate = ratePlan.roomRates.find(e => e.id === roomRateId);
            if (!roomRate) return false;

            if (restriction === 'price') {
              const special = roomRate.roomRateSpecials.find(x => x.appliedDate === currentDateString);
              return special && special.pricePax == value;
            }
            const restrictionKey = restriction === 'stopSell' ? 'stopLimit' : restriction;
            if (roomRate.restrictionsGroupBy &&
              roomRate.restrictionsGroupBy[currentDateString] &&
              roomRate.restrictionsGroupBy[currentDateString][0] &&
              roomRate.restrictionsGroupBy[currentDateString][0][restrictionKey] !== undefined
            ) {
              const res = roomRate.restrictionsGroupBy[currentDateString][0][restrictionKey];
              return res == value;
            }
          });
          if (!isValid) return false;
        }
        return true;
      };
      return dates.every(checkCondition);
    },
    tryUpdate(room, roomId, ratePlanId, roomRateId, fromDate, toDate, restriction, value, updateType) {
      const delay = ms => new Promise(resolve => setTimeout(resolve, ms));
      const tryUpdateRecursively = async (attempts = 0) => {
        const waitTime = attempts === 0 ? 1000 : 10000;
        await delay(waitTime);
        let isUpdated = false;
        if (updateType == 'roomRate') {
          let ratePlanIds = [];
          if (['sellLimit', 'stopSell'].includes(restriction)) {
            ratePlanIds = [];
            this.selectedSalePackage.forEach((e) => {
              if (this.listRateCategory.includes(e) || e == -1) {
                const arrPlanIds = this.listRatePlanByRateCategory
                  .find((item) => item.id === e)
                  .children.map((c) => c.id);
                ratePlanIds = ratePlanIds.concat(arrPlanIds);
              } else {
                ratePlanIds.push(e);
              }
            });
          } else {
            ratePlanIds = [ratePlanId];
          }
          await this.getFilterRestrictionByRoomRate(roomId, ratePlanIds, room.selectedOta);
          isUpdated = this.checkUpdated(roomId, ratePlanIds, roomRateId, fromDate, toDate, restriction, value);
        }

        if (updateType == 'room') {
          const data = await this.getRelationByRoomId(roomId);
          isUpdated = this.checkUpdated(roomId, ratePlanId, roomRateId, fromDate, toDate, restriction, value, data);
          if (isUpdated && restriction == 'inventory') {
            let roomInventoryUpdate = this.relationData.find((e) => e.id == data.id);
            roomInventoryUpdate.availByDate = data.availByDate;
            this.$forceUpdate();
          }

          if (isUpdated && restriction == 'HOTEL_ROOM_RATE') {
            let roomUpdate = this.relationData.find((e) => e.id == data.id);
            roomUpdate.roomTypeSpecials = data.roomTypeSpecials;
            this.$forceUpdate();
          }
        }
        if (!isUpdated && attempts < 2) {
          await tryUpdateRecursively(attempts + 1);
        }
      };
      tryUpdateRecursively();
    },
    async getRoomRate(body) {
      const res = await service.getRoomRate(body);
      if (res.responseCode === 0) {
        return res.data;
      } else {
        return null;
      }
    },
    async getFilterRestrictionByRoomRate(roomId, ratePlanIds, otaIds) {
      const fromDate = this.selectedDatePicker;
      const toDate = moment(this.selectedDatePicker).add(30, "day").format("YYYY-MM-DD");
      if (ratePlanIds.length == 0) {
        this.selectedSalePackage.forEach((e) => {
          if (this.listRateCategory.includes(e) || e == -1) {
            const arrPlanIds = this.listRatePlanByRateCategory
              .find((item) => item.id === e)
              .children.map((c) => c.id);
            ratePlanIds = ratePlanIds.concat(arrPlanIds);
          } else {
            ratePlanIds.push(e);
          }
        });
      }
      const body = {
        from: fromDate,
        to: toDate,
        roomTypeId: roomId,
        otaIds: otaIds,
        ratePlanIds: ratePlanIds
      };
      const res = await sale_room.getRestrictionByRoomRate(body);
      if (res.responseCode == 0 && res.data.length > 0) {
        const data = res.data;
        data.forEach((ratePlan) => {
          ratePlan.roomRates.forEach((rr) => {
            rr.metaData = "closed";
            rr.restrictionsGroupBy = rr.restrictions.length > 0 
              ? this.groupBy(rr.restrictions,"appliedDate") 
              : [];
          });
        });

        const room = this.relationData.find(e => e.id == roomId);
        if (room) {
          data.forEach(newRatePlan => {
            const ratePlanIndex = room.ratePlans.findIndex(plan => plan.id === newRatePlan.id);
            if (ratePlanIndex !== -1) {
              room.ratePlans[ratePlanIndex] = newRatePlan;
            }
          });
        }
        this.$forceUpdate();
      }
    },
    async getRelationByRoomId(roomId) {
      var fromDate = this.selectedDatePicker;
      var toDate = moment(this.selectedDatePicker).add(30, "day").format("YYYY-MM-DD");
      let roomTypeIds = [];
      roomTypeIds.push(roomId);

      let body = {
        from: fromDate,
        to: toDate,
        roomTypeIds: roomTypeIds,
      };
      const res = await sale_room
        .getAllSaleRoom(body);
      if (res.responseCode === 0) {
        let data = res.data;
        data.forEach((re) => {
          re.availByDate = this.groupBy(re.availabilities, "appliedDate");
        });
        return data.length > 0 ? data[0] : null;
      } else {
        return null;
      }
    },
    saveRestriction() {
      let ratePlanId = this.quickUpdate.roomSale.ratePlan.id;
      let roomId = this.quickUpdate.roomSale.room.id;
      let roomRateId = this.quickUpdate.roomSale.roomRate.id;
      let price = this.quickUpdate.price;
      let quantity = this.quickUpdate.quantity;
      quantity = quantity ? quantity.toString().replace(/[^\d]/g,'') : 0;
      if(!this.checkProtectionRate()) return;
      if (this.get_day_of_time(new Date(this.quickUpdate.startDate), new Date(this.quickUpdate.endDate)) > 365) {
        _alert(null, this.$t("UPDATE_INTERVAL_IS_NOT_MORE_THAN_ONE_YEAR"));
        return;
      }
      //cập nhật phòng
      if(['inventory', 'price', 'HOTEL_ROOM_RATE'].includes(this.quickUpdate.restriction)) {
        let body = [];
        let dateValue = [];
        if(this.quickUpdate.restriction == 'inventory') {
          if (
            quantity === null ||
            quantity === "" ||
            quantity < 0 ||
            quantity > 9999
          ) {
            _alert(null, this.$t("DATA_INPUT_INVALID"));
            return
          }
          this.quickUpdate.dateList.forEach((item) => {
              dateValue.push({
                apply: item.applyDate,
                value: parseInt(quantity)
              });
          });
          body.push({
            id: roomId,
            dates: dateValue
          });
          this.updateInventory(body);
        }

        if(['price'].includes(this.quickUpdate.restriction)) {
          let isValid = this.validateBasePrice(this.quickUpdate.roomRate, this.quickUpdate.startDate, this.quickUpdate.endDate);
          if (isValid == false) {
            this.priceInvalidDialog = true;
            return
          }

          if (price <= 0) {
            _alert(null, this.$t("DATA_INPUT_INVALID"));
            return
          }
          this.quickUpdate.dateList.forEach((item) => {
              dateValue.push({
                apply: item.applyDate,
                value: price
              });
          });

          body.push({
            id: roomRateId,
            dates: dateValue
          });
          this.saveSpecialPrice(body);
        }
        if(['HOTEL_ROOM_RATE'].includes(this.quickUpdate.restriction)) {
          if (price <= 0) {
            _alert(null, this.$t("DATA_INPUT_INVALID"));
            return
          }
          this.quickUpdate.dateList.forEach((item) => {
              dateValue.push({
                apply: item.applyDate,
                value: price
              });
          });

          body.push({
            id: roomId,
            dates: dateValue
          });
          this.updateHotelRoomRate(body);
        }
      } else if(['stopSell', 'sellLimit'].includes(this.quickUpdate.restriction)) { // giới hạn bán
        const dates = [];
        this.quickUpdate.dateList.forEach((item) => {
            dates.push({
              apply: item.applyDate,
              value: parseInt(quantity)
            });
        });

        if (this.quickUpdate.restriction == 'stopSell') {
          const body = [];
          const data = {
            id: roomId,
            dates: dates
          }
          body.push(data);
          let otas = [];
          otas.push(this.quickUpdate.roomSale.ota.id);
          this.serviceUpdateStopSell(body, otas);
        }

        if (this.quickUpdate.restriction == 'sellLimit') {
          const body = [];
          body.push({
            id: roomId,
            ota: [
              {
                id: this.quickUpdate.roomSale.ota.groupId,
                dates: dates
              }
            ]
          });
          this.serviceUpdateSellLimit(body);
        }
      } else {
        this.updateQuickRestriction();
      }
    },
    // cập nhật phòng trống
    updateInventory(body) {
      this.isUpdate = true;
      service
        .updateAvailable(body)
        .then(res => {
          _alert(res, this.$t(res.data), false);
          if (res.responseCode == 0) {
            const { ratePlan, room, roomRate, restriction } = this.quickUpdate;
            const [fromDate, toDate] = this.quickUpdate.dateRange;
            const value = body[0].dates[0].value;
            this.quickUpdateDialog = false;
            this.tryUpdate(room, room.id, ratePlan.id, roomRate.id, fromDate, toDate, restriction, value, 'room');
          }
        })
        .finally(() => {
          this.isUpdate = false;
        });
    },
    //cập nhật giá bán
    saveSpecialPrice(body) {
      this.isUpdate = true;
      sale_room
        .updateSpecialPrice(body)
        .then(res => {
          _alert(res, this.$t(res.data), false);
          if (res.responseCode == 0) {
            const { ratePlan, room, roomRate, restriction } = this.quickUpdate;
            const [fromDate, toDate] = this.quickUpdate.dateRange;
            const value = body[0].dates[0].value;
            this.quickUpdateDialog = false;
            this.tryUpdate(room, room.id, ratePlan.id, roomRate.id, fromDate, toDate, restriction, value, 'roomRate');
          }
        }).finally(() => {
          this.isUpdate = false;
        });
    },
    //xác nhận xoá giá ngày
    delSpecialPriceConfirm() {
      if (this.get_day_of_time(new Date(this.quickUpdate.startDate), new Date(this.quickUpdate.endDate)) > 365) {
        _alert(null, this.$t("UPDATE_INTERVAL_IS_NOT_MORE_THAN_ONE_YEAR"));
        return;
      }
      let specialDateIds = this.quickUpdate.dateList
                          .filter(item => item.id != null)
                          .map(item => item.id);
      this.$refs.deleteSpecialPriceDialogComponent.open({
        ids: specialDateIds
      });
    },
    //xoá giá ngày
    delSpecialPrice(specialDateIds) {
      this.isUpdate = true;
      sale_room
        .removeSpecialPrice(specialDateIds.ids)
        .then(res => {
          _alert(res, this.$t(res.data), false);
          if (res.responseCode == 0) {
            const { ratePlan, room, roomRate, restriction } = this.quickUpdate;
            const [fromDate, toDate] = this.quickUpdate.dateRange;
            this.quickUpdateDialog = false;
            this.tryUpdate(room, room.id, ratePlan.id, roomRate.id, fromDate, toDate, restriction, -1, 'roomRate');
          }
        }).finally(() => {
          this.isUpdate = false;
        });
    },
    //cập nhật restriction
    async updateQuickRestriction() {
      let start = moment(this.quickUpdate.dateRange[0], "YYYY-MM-DD");
      let end = moment(this.quickUpdate.dateRange[1], "YYYY-MM-DD");
      let value = "";
      if (['closedOnArrival', 'closedOnDeparture', 'closed'].includes(this.quickUpdate.restriction)) {
        value = this.quickUpdate.selected;
      } else {
        value = this.quickUpdate.quantity;
        const number = parseInt(value, 0);
        if (isNaN(number) || number < 0 || !Number.isInteger(number)) {
            _alert(null, this.$t("DATA_INPUT_INVALID"));
            return;
        }
      }

      if (['minBookingWindowByHour', 'maxBookingWindowByHour'].includes(this.quickUpdate.restriction) && value > 23) {
        _alert(null, this.$t("VALUE_MUST_BE_LESS_THAN_24H"));
        return;
      }

      let body = {
        otaId: this.quickUpdate.roomSale.ota.id,
        ratePlanId: this.quickUpdate.roomSale.ratePlan.id,
        restrictionPlanId: this.quickUpdate.roomSale.restrictionPlanId,
        roomTypeId: this.quickUpdate.roomSale.room.id,
        updateField: this.quickUpdate.restriction,
        fromTo: [
          {
            dateStart: start.format("YYYY-MM-DD"),
            dateEnd: end.format("YYYY-MM-DD"),
            restrictions: []
          }
        ]
      }
      let dayOfWeekList = [
        {
          dayOfWeek: 1,
          value: "",
          disable: true,
          
        },
        {
          dayOfWeek: 2,
          value: "",
          disable: true,
          
        },
        {
          dayOfWeek: 3,
          value: "",
          disable: true,
          
        },
        {
          dayOfWeek: 4,
          value: "",
          disable: true,
          
        },
        {
          dayOfWeek: 5,
          value: "",
          disable: true,
          
        },
        {
          dayOfWeek: 6,
          value: "",
          disable: true,
          
        },
        {
          dayOfWeek: 7,
          value: "",
          disable: true,
          
        },
      ];
      let day = moment.duration(end.diff(start)).asDays();
      if (day < 6) {
        while (start <= end) {
          let daysOfWeek = start.day() === 0 ? 7 : start.day();
          dayOfWeekList.find((e) => e.dayOfWeek === daysOfWeek).disable = false;
          dayOfWeekList.find((e) => e.dayOfWeek === daysOfWeek).value = value;
          start = moment(start).add(1, "day");
        }
      } else {
        dayOfWeekList.forEach((e) => {
          e.disable = false;
          e.value = value;
        });
      }
      body.fromTo[0].restrictions = dayOfWeekList;
      let data = [];
      data.push(body);
      this.isUpdate = true;
      restriction
      .batchUpdate(data)
      .then((res) => {
        _alert(res, this.$t(res.data), false);
        if (res.responseCode == 0) {
          const { ratePlan, room, roomRate, restriction } = this.quickUpdate;
          const [fromDate, toDate] = this.quickUpdate.dateRange;
          this.quickUpdateDialog = false;
          this.tryUpdate(room, room.id, ratePlan.id, roomRate.id, fromDate, toDate, restriction, value, 'roomRate');
        }
      }).finally(() => {
          this.isUpdate = false;
        });
    },
    //cập nhật giá phòng
    updateHotelRoomRate(body) {
      this.isUpdate = true;
      sale_room
        .updateSpecialPriceRoom(body)
        .then((res) => {
          _alert(res, this.$t(res.data), false);
          if (res.responseCode == 0) {
            const { ratePlan, room, roomRate, restriction } = this.quickUpdate;
            const [fromDate, toDate] = this.quickUpdate.dateRange;
            const value = body[0].dates[0].value;
            this.quickUpdateDialog = false;
            this.tryUpdate(room, room.id, ratePlan.id, roomRate.id, fromDate, toDate, restriction, value, 'room');
          }
        }).finally(() => {
          this.isUpdate = false;
        });
    },
    //cập nhật giới hạn ngừng bán
    async serviceUpdateStopSell(body, otas) {
      await service.updateStopSell(body, otas)
      .then((res) => {
        _alert(res, this.$t(res.data), false);
        if (res.responseCode == 0) {
          const { ratePlan, room, roomRate, restriction } = this.quickUpdate;
          const [fromDate, toDate] = this.quickUpdate.dateRange;
          const value = body[0].dates[0].value;
          this.quickUpdateDialog = false;
          this.tryUpdate(room, room.id, ratePlan.id, roomRate.id, fromDate, toDate, restriction, value, 'roomRate');
        }
      }).finally(() => {
        this.isUpdate = false;
      });
    },
    //cập nhật giới hạn bán
    async serviceUpdateSellLimit(body) {
      await service.updateSellLimit(body)
      .then((res) => {
        _alert(res, this.$t(res.data), false);
        if (res.responseCode == 0) {
          const { ratePlan, room, roomRate, restriction } = this.quickUpdate;
          const [fromDate, toDate] = this.quickUpdate.dateRange;
          const value = body[0].ota[0].dates[0].value;
          this.quickUpdateDialog = false;
          this.tryUpdate(room, room.id, ratePlan.id, roomRate.id, fromDate, toDate, restriction, value, 'roomRate');
        }
      }).finally(() => {
        this.isUpdate = false;
      });
    },
    checkIsUpdate(room, ratePlan, roomRate, restriction) {
      if(restriction == 'inventory') {
        return this.checkRoleFunc('INVENTORY') && this.syncInventory === false && !room.parent;
      }
      if(['price'].includes(restriction)) {
        return this.checkRoleFunc('RATE') && !roomRate.linkedRoomRateId && roomRate.ota.otaCode != 'EZ_PMS';
      }

      if(['HOTEL_ROOM_RATE'].includes(restriction)) {
        return this.checkRoleFunc('RATE');
      }

      if(['sellLimit'].includes(restriction)) {
        return !room.parent && roomRate.ota.otaCode !== 'EZ_PMS' && this.checkRoleFunc('STOP_SELL_LIMIT');
      }

      if(['stopSell'].includes(restriction)) {
        return this.checkRoleFunc('STOP_SELL_LIMIT');
      }

      if (['priceExtraAdult', 'priceExtraChild', 'priceExtraBaby'].includes(restriction)) {
        return false;
      }
      return true;
    },
    getRestrictionPlanId() {
      let body = {};
      body.keyword = "";
      body.status = 1;
      body.limit = 100;
      body.offset = 0;
      body.orderBy = "active";
      body.asc = true;

      restriction.getAllPackageRestriction(body).then((res) => {        
        if (res.responseCode == 0) {
          let response = res.data.map((x) => {
            return {
              value: x.id,
              text: x.nameVi,
            };
          });
          if (response.length > 0) {
            this.quickUpdate.roomSale.restrictionPlanId = response[0].value;
          }
        }
      });
    },
    validateQuantity(event, quickUpdate) {
      let sanitizedValue = event.replace(/[^\d]/g, '');
      if (sanitizedValue.length > 1 && sanitizedValue.charAt(0) === '0') {
        sanitizedValue = sanitizedValue.substring(1);
      }
      this.$set(quickUpdate, 'quantity', sanitizedValue || 0);
      this.$forceUpdate();
    },
    validateBasePrice(roomRate, from, to) {
      let isValid = true;
      let start = moment(from, "YYYY-MM-DD");
      let end = moment(to, "YYYY-MM-DD");

      let priceBase = {
        0: roomRate.paxSunday,
        1: roomRate.paxMonday,
        2: roomRate.paxTuesday,
        3: roomRate.paxWednesday,
        4: roomRate.paxThursday,
        5: roomRate.paxFriday,
        6: roomRate.paxSaturday
      }
      while (start <= end) {
        let daysOfWeek = start.day();
          if(priceBase[daysOfWeek] <= 0) {
            isValid = false;
          }
          start = moment(start).add(1, "day");
        }
        return isValid;
    },
    loadData(event) {
      if (this.loadingMore) {
        return;
      }
      const table = event.target;
      const scrollTop = table.scrollTop;
      const clientHeight = table.clientHeight;
      const scrollHeight = table.scrollHeight;
      if (scrollHeight - scrollTop - clientHeight > 100) {
        return;
      }
      if (this.tmpRelationData.length > this.relationData.length) {
        this.loadingMore = true;
        const requestId = this.relationRequestId;
        this.loadMoreTimer = setTimeout(() => {
          if (requestId !== this.relationRequestId) {
            return;
          }
          this.appendNextPage();
          this.loadingMore = false;
        }, 1000);
      } else if (this.loadingRelation) {
        this.loadingMore = true;
        this.waitingLoadMore = true;
      }
    },
    fillIfAtBottom(requestId) {
      const el = this.$refs.scrollableDiv;
      if (
        !el ||
        requestId !== this.relationRequestId ||
        this.loadingMore ||
        this.tmpRelationData.length <= this.relationData.length
      ) {
        return;
      }
      if (el.scrollHeight - el.scrollTop - el.clientHeight <= 100) {
        this.appendNextPage();
      }
    },
    appendNextPage() {
      const start = this.relationData.length;
      this.relationData = [
        ...this.relationData,
        ...this.tmpRelationData.slice(start, start + this.itemsPerPage),
      ];
      this.perPage = Math.ceil(this.relationData.length / this.itemsPerPage);
    },
    caculatorApi(roomTypeIds) {
      const totalApi = Math.ceil(roomTypeIds.length / this.quantityRequest);
      let itemChunk = [];
      for(let i = 0; i < totalApi; i++) {
        itemChunk.push(roomTypeIds.slice(i * this.quantityRequest, (i + 1) * this.quantityRequest));
      }
      return itemChunk;
    },
    async getRelation(isSearch) {
      if (
        this.controller && 
        this.controller instanceof AbortController && 
        !this.controller.signal.aborted
      ) {
        this.controller.abort();
      }
      this.controller = new AbortController();
      const signal = this.controller.signal;

      this.relationRequestId += 1;
      const requestId = this.relationRequestId;
      clearTimeout(this.loadMoreTimer);
      this.relationData = [];
      this.tmpRelationData = [];
      this.perPage = 0;
      this.totalPage = 0;
      this.loadingMore = false;
      this.waitingLoadMore = false;
      this.loadingRelation = true;
      var fromDate = this.selectedDatePicker;
      var toDate = moment(this.selectedDatePicker).add(15, "day").format("YYYY-MM-DD");

      this.loadDateList();
      var roomTypeIds = [];
      this.selectedRoom.forEach((e) => {
        if (this.listRoomCategory.includes(e) || e == -1) {
          var arrRoomIds = this.listRoomTypeByRoomCategory
            .find((item) => item.id === e)
            .children.map((c) => c.id);
          roomTypeIds = roomTypeIds.concat(arrRoomIds);
        } else {
          roomTypeIds.push(e);
        }
      });

      let body = {
        from: fromDate,
        to: toDate,
        roomTypeIds: roomTypeIds.length > 0 ? [...roomTypeIds] : [],
      };
      const queryString = window.location.href;
     const ob = JSON.parse(localStorage.getItem("arrToken")).filter(e => e.hotel !== null && e.hotel.id === queryString.split('/')[4])[0];
      localStorage.setItem(
        "roomSaleOtaSearch",
        JSON.stringify({
          hotelId: ob.hotel.id,
          from: this.selectedDatePicker,
          selectedSalePackage: this.selectedSalePackage,
          selectedRoom: this.selectedRoom
        })
      );

      try {
        const itemChunk = this.caculatorApi(body.roomTypeIds);
        for (let i = 0; i < itemChunk.length; i++) {
          if (signal.aborted) {
            return;
          }

          if (i > 0) {
            await new Promise((resolve) => setTimeout(resolve, 1000));
            if (signal.aborted) {
              return;
            }
          }

          body.roomTypeIds = itemChunk[i];
          const res = await sale_room.getAllSaleRoom(body, signal);
          if (signal.aborted || requestId !== this.relationRequestId) {
            return;
          }
          if (res.responseCode === 0) {
            const data = res.data.map((re) => {
              re.textSearch = "";
              re.selectedOta = [];
              re.isLoading = false;
              re.ratePlanLoading = false;
              re.availByDate = this.groupBy(re.availabilities, "appliedDate");
              re.controller = null;
              return re;
            });
            this.tmpRelationData = [...this.tmpRelationData, ...data];
            this.totalPage = Math.ceil(this.tmpRelationData.length / this.itemsPerPage);
            if (this.relationData.length < this.itemsPerPage && this.tmpRelationData.length > this.relationData.length) {
              this.appendNextPage();
            }
            this.isLoading = false;

            if (this.waitingLoadMore && this.tmpRelationData.length > this.relationData.length) {
              this.appendNextPage();
              this.loadingMore = false;
              this.waitingLoadMore = false;
            } else if (!this.loadingMore) {
              this.$nextTick(() => this.fillIfAtBottom(requestId));
            }
          }
        }
      } catch (error) {
        if (error.name !== "AbortError") {
          _alert({}, this.$t('ERROR'), false);
        }
      } finally {
        if (requestId === this.relationRequestId) {
          this.isLoading = false;
          this.loadingRelation = false;
          if (this.waitingLoadMore) {
            this.loadingMore = false;
            this.waitingLoadMore = false;
          }
        }
      }
    },
    async getRestrictionByRoomRate(room, time) {
      if (
        room.controller && 
        room.controller instanceof AbortController && 
        !room.controller.signal.aborted
      ) {
        room.controller.abort();
      }
      
      room.controller = new AbortController();
      const signal = room.controller.signal; 

      const fromDate = this.selectedDatePicker;
      const toDate = moment(this.selectedDatePicker).add(15, "day").format("YYYY-MM-DD");
      let ratePlanIds = [];
      this.selectedSalePackage.forEach((e) => {
        if (this.listRateCategory.includes(e) || e == -1) {
          const arrPlanIds = this.listRatePlanByRateCategory
            .find((item) => item.id === e)
            .children.map((c) => c.id);
          ratePlanIds = ratePlanIds.concat(arrPlanIds);
        } else {
          ratePlanIds.push(e);
        }
      });

      if ((time && room.selectedOta.length == 0) || ratePlanIds.length == 0) {
        room.isLoading = false;
        return
      };

      const totalApi = Math.ceil(ratePlanIds.length / 2);
      let itemChunk = [];
      for(let i = 0; i < totalApi; i++) {
        itemChunk.push(ratePlanIds.slice(i * 2, (i + 1) * 2));
      }
      const bodyTemplate = {
        from: fromDate,
        to: toDate,
        roomTypeId: room.id,
        otaIds: room.selectedOta,
      };

      room.isLoading = time != true;
      this.$set(room, 'ratePlans', []);
      
      try {
        const requests = itemChunk.map(chunk => {
          const body = { ...bodyTemplate, ratePlanIds: chunk };
          return sale_room.getRestrictionByRoomRate(body, signal);
        });

        const responses = await Promise.all(requests);

        if (signal.aborted) {
          this.$set(room, 'ratePlans', []);
          return;
        }

        responses.forEach(res => {
          if (res.responseCode == 0 && res.data.length > 0) {
            res.data.forEach(ratePlan => {
              ratePlan.roomRates.forEach(rr => {
                rr.metaData = "closed";
                rr.restrictionsGroupBy = rr.restrictions.length > 0 
                  ? this.groupBy(rr.restrictions, "appliedDate") 
                  : [];
              });
              room.ratePlans.push(ratePlan);
            });
          }
        });
        room.controller = null;
        this.$forceUpdate();
      } catch (error) {
        if (error.name !== "AbortError") {
          room.isLoading = false;
          _alert({}, this.$t('ERROR'), false);
        }
      } finally {
        room.isLoading = false;
        this.$forceUpdate();
      }
    },
    change() {
      if (this.changeSelect === true) {
        this.changeSearchCondition(true);
        this.changeSelect = false;
      }
      this.isOpen = false;
    },
    open() {
      this.isOpen = true;
    },
    changeMeta(data) {
      data = this.sortMetas(data);
      this.metas = data.filter((e) => e !== "HOTEL_ROOM_RATE");
      localStorage.setItem("currentFilterRoomSale", JSON.stringify(this.metas));
      this.$forceUpdate();
    },
    rowspanCol(otaCode, length) {
      if (otaCode !== 'EZ_BE') {
        if (this.metas.includes('minBookingWindow') && this.metas.includes('maxBookingWindow')) {
          return length - 1;
        } else if (this.metas.includes('minBookingWindow') || this.metas.includes('maxBookingWindow')) {
          return length;
        } else {
          return length + 1;
        }
      } else {
        return length + 1;
      }
    },
    sortMetas(data) {
      return data.sort((a, b) => {
        const sortInxA = this.listMetaData.find(item => item.value == a).sortInx;
        const sortInxB = this.listMetaData.find(item => item.value == b).sortInx;
        return sortInxA - sortInxB;
      });
    },
    findName(data) {
      return data.find((x) => x.lang == this.defaultI18n).name;
    },
    checkSpecialPrice(rr, date) {
      var data = rr;
      if (
        data["roomRateSpecials"] &&
        data["roomRateSpecials"].length > 0 &&
        data["roomRateSpecials"].filter((x) => x.appliedDate == date).length > 0 &&
        data["roomRateSpecials"].find((x) => x.appliedDate == date).pricePax != -1
      ) {
        return this.parseRoomRateSpecial(
          data["roomRateSpecials"].find((x) => x.appliedDate == date).priceBy
        );
      } else return "";
    },
    checkSpecialPriceRoom(room, date) {
      if (
        room.roomTypeSpecials &&
        room.roomTypeSpecials.length > 0 &&
        room.roomTypeSpecials.filter((x) => x.appliedDate === date).length > 0 &&
        room.roomTypeSpecials.find((x) => x.appliedDate === date).pricePax != -1
      ) {
        return room.roomTypeSpecials.find((x) => x.appliedDate == date).pricePax;
      } else return "";
    },
    parseRoomRateSpecial(value) {
      switch (value) {
        case 0:
          return "font-weight-bold";
        case 1:
          return "font-weight-bold text-smart";
        case 2:
          return "font-weight-bold text-master-rate";
        default:
          return "";
      }
    },
    genClassAvai(data, date) {
      var value = data.find((x) => x.appliedDate == date).quantity;
      return value;
    },
    openPopupUpdateRate(avail, roomPlan, room, closed, rr) {
      if (this.checkRoleFunc('RATE') == false) return
      if (rr.linkedRoomRateId || rr.ota.otaCode == "EZ_PMS") return;
      this.dateUpdate = avail.date;
      if (
        rr.roomRateSpecials.length > 0 &&
        rr.roomRateSpecials.filter((x) => x.appliedDate == avail.date).length > 0 &&
        rr.roomRateSpecials.filter((x) => x.appliedDate == avail.date)[0].pricePax != -1
      ) {
        this.priceUpdate = rr.roomRateSpecials.filter(
          (x) => x.appliedDate == avail.date
        )[0].pricePax;
      } else {
        this.priceUpdate = rr[this.formatDateOfWeekInPrice(avail.date)];
      }
      this.idUpdateRate = rr.id;
      this.rateUpdate = roomPlan;
      this.roomUpdate = room;
      this.isUpdateStopSell = closed;
      this.roomRateUpdate = rr;
      this.dialogUpdateRate = true;
    },
    confirmUpdateSpecialPrice() {
      var body = [];
      var dateValue = [];
      dateValue.push({
        apply: moment(new Date(this.dateUpdate)).format("YYYY-MM-DD"),
        value: this.priceUpdate,
      });
      if (this.priceUpdate > 0) {
        body.push({
          id: this.idUpdateRate,
          dates: dateValue,
        });
      } else {
        _alert(null, this.$t("DATA_INPUT_INVALID"));
        return;
      }
      sale_room
        .updateSpecialPrice(body)
        .then((res) => {
          _alert(res, this.$t(res.data), false);
        })
        .finally(() => {
          this.dialogUpdateRate = false;
          this.getRestrictionByRoomRate(this.roomUpdate);
        });
    },
    confirmUpdateSpecialPriceRoom() {
      var body = [];
      var dateValue = [];
      dateValue.push({
        apply: moment(new Date(this.dateUpdate)).format("YYYY-MM-DD"),
        value: this.priceUpdate,
      });
      if (this.priceUpdate > 0) {
        body.push({
          id: this.roomUpdate.id,
          dates: dateValue,
        });
      } else {
        _alert(null, this.$t("DATA_INPUT_INVALID"));
        return;
      }
      sale_room
        .updateSpecialPriceRoom(body)
        .then((res) => {
          _alert(res, this.$t(res.data), false);
        })
        .finally(() => {
          this.dialogUpdateRoomPrice = false;
          this.changeDate();
        });
    },
    openPopupUpdateAvai(avail, room) {
      if (this.checkRoleFunc('INVENTORY') == false) return
      if (this.syncInventory === false && !room.parent) {
        this.dateUpdate = avail.date;
        this.roomIdUpdate = room.id;
        this.roomUpdate = room;
        this.roomAvai = +room.availabilities.find((x) => x.appliedDate == avail.date)
          .quantity;
        this.dialogUpdateAvai = true;
      } else if (room.parent) {
        _alert(null, this.$t("ROOM_DERIVE"), false);
        return;
      } else if (this.syncInventory) {
        _alert(null, this.$t("HOTEL_SYNC"), false);
        return;
      }
    },
    openPopupUpdateRoomPrice(avail, room) {
      if (this.checkRoleFunc('RATE') == false) return
      this.dateUpdate = avail.date;
      if (
        room.roomTypeSpecials.length > 0 &&
        room.roomTypeSpecials.filter((x) => x.appliedDate === this.dateUpdate).length >
          0 &&
        room.roomTypeSpecials.find((x) => x.appliedDate === this.dateUpdate).pricePax !=
          -1
      ) {
        this.priceUpdate = room.roomTypeSpecials.find(
          (x) => x.appliedDate === this.dateUpdate
        ).pricePax;
      } else {
        this.priceUpdate = avail.isWeekend ? room.weekendPrice : room.defaultPrice;
      }
      this.roomUpdate = room;
      this.dialogUpdateRoomPrice = true;
    },
    confirmUpdateRoomAvail() {
      if (
        this.roomAvai === null ||
        this.roomAvai === "" ||
        this.roomAvai < 0 ||
        this.roomAvai > 9999
      ) {
        _alert(null, this.$t("DATA_INPUT_INVALID"));
        return;
      }
      var body = [
        {
          id: this.roomIdUpdate,
          dates: [
            {
              apply: moment(new Date(this.dateUpdate)).format("YYYY-MM-DD"),
              value: this.roomAvai,
            },
          ],
        },
      ];
      service
        .updateAvailable(body)
        .then((res) => {
          _alert(res, this.$t(res.data), false);
        })
        .finally(() => {
          this.dialogUpdateAvai = false;
          this.changeDate();
        });
    },
    confirmUpdateRestriction(val) {
      var body = {
        restrictionId: this.idUpdateStopsell,
        value: val,
      };
      sale_room
        .updateStopsellDay(body)
        .then((res) => {
          _alert(res, this.$t(res.data), false);
        })
        .finally(() => {
          this.dialogUpdateStopSell = false;
          this.getRestrictionByRoomRate(this.roomUpdate);
        });
    },
    openPopupUpdateRestriction(meta, ratePlan, rr, restriction, room) {
      if (this.checkRoleFunc('RESTRICTION') == false) return
      if (meta !== "closed") {
        return;
      }
      this.selectedOTA = rr.ota.id
      this.roomUpdate = room;
      this.rateUpdate = ratePlan;
      this.isUpdateStopSell = restriction.closed;
      this.idUpdateStopsell = restriction.id;
      this.dateUpdate = restriction.appliedDate;
      this.dialogUpdateStopSell = true;
    },
    isLeapYear() {
      return (
        this.currentYear % 400 === 0 ||
        (this.currentYear % 100 !== 0 && this.currentYear % 4 === 0)
      );
    },
    // Khi click đổi sang xem dạng lịch
    getRateCalendar(useFirstRoom) {
      this.isLoading = true;
      // Reset lai data cua lich
      this.calendarListSalePackage = [];
      this.calendarRate = [];
      // Hiển thị lịch
      this.view = "calendar";
      // List phòng dùng chung với dạng bảng, neu dang chon tat ca phong thi khi chuyen tab, chon phong dau tien
      if (this.selectedRoomCalendar == "-1") {
        this.selectedRoomCalendar = this.listRoom[0].value;
      }

      let body = {
        roomIds:
          this.selectedRoomCalendar == "-1"
            ? [this.listRoom[0].value]
            : [this.selectedRoomCalendar],
        // year: moment(this.calendarCurrentMonthYear).format("YYYY"),
        year: this.currentYear,
        // month: moment(this.calendarCurrentMonthYear).format("MM"),
        month: null,
        ota: this.selectedOTA,
      };

      service
        .getDetailRoomRate(body)
        .then((res) => {
          if (res.responseCode === 0) {
            // Lấy data hiển thị cho table
            this.calendarRate = [...res.data];
            // // console.log(this.calendarRate);
            // Lấy danh sách gói bán của phòng hiện tại, mặc định là gói đầu tiên được chọn nên ko có trường hợp mảng lớn hơn 1
            this.calendarListSalePackage = res.data[0].ratePlans.map((x) => {
              return {
                value: x.id,
                text: x.i18ns.find((y) => y.lang == this.defaultI18n).name,
              };
            });
            this.calendarListSalePackage = this.calendarListSalePackage.filter(
              (x) => x.value
            );
            if (useFirstRoom) {
              this.calendarCurrentSalePackage = this.calendarListSalePackage[0].value;
            }
          } else {
            _alert(res, this.$t(res.data), false);
          }
        })
        .finally(() => (this.isLoading = false));
    },
    onResize() {
      this.maxHeight = window.innerHeight - 60 - 68 - 46 - 16 - 70 - 60;
    },
    formatDateOfWeekInPrice(date) {
      let dayOfWeek;
      switch (moment(date).day()) {
        case 0: {
          dayOfWeek = "paxSunday";
          break;
        }
        case 1: {
          dayOfWeek = "paxMonday";
          break;
        }
        case 2: {
          dayOfWeek = "paxTuesday";
          break;
        }
        case 3: {
          dayOfWeek = "paxWednesday";
          break;
        }
        case 4: {
          dayOfWeek = "paxThursday";
          break;
        }
        case 5: {
          dayOfWeek = "paxFriday";
          break;
        }
        case 6: {
          dayOfWeek = "paxSaturday";
          break;
        }
      }
      return dayOfWeek;
    },
    formatDateOfWeek(date) {
      let dayOfWeek;
      switch (date.day()) {
        case 0: {
          dayOfWeek = "SUN";
          break;
        }
        case 1: {
          dayOfWeek = "MON";
          break;
        }
        case 2: {
          dayOfWeek = "TUE";
          break;
        }
        case 3: {
          dayOfWeek = "WED";
          break;
        }
        case 4: {
          dayOfWeek = "THU";
          break;
        }
        case 5: {
          dayOfWeek = "FRI";
          break;
        }
        case 6: {
          dayOfWeek = "SAT";
          break;
        }
      }
      return dayOfWeek;
    },
    formatDate(date) {
      var currentDate = moment(date, "YYYY-MM-DD");
      if (!currentDate.isValid()) {
        return "";
      }
      let dayOfWeek = "";
      switch (currentDate.day()) {
        case 0: {
          dayOfWeek = this.$t("SUN_SHORT").toString();
          break;
        }
        case 1: {
          dayOfWeek = this.$t("MON_SHORT").toString();
          break;
        }
        case 2: {
          dayOfWeek = this.$t("TUE_SHORT").toString();
          break;
        }
        case 3: {
          dayOfWeek = this.$t("WED_SHORT").toString();
          break;
        }
        case 4: {
          dayOfWeek = this.$t("THU_SHORT").toString();
          break;
        }
        case 5: {
          dayOfWeek = this.$t("FRI_SHORT").toString();
          break;
        }
        case 6: {
          dayOfWeek = this.$t("SAT_SHORT").toString();
          break;
        }
      }
      return (
        '<div class="day-week">' +
        dayOfWeek +
        '</div><div class="day-day font-weight-bold">' +
        currentDate.format("DD") +
        '</div><div class="day-month">' +
        this.$t(currentDate.format("MMM").toUpperCase() + "_SHORT") +
        "</div>"
      );
    },
    loadDateList() {
      let hotelWeekend = JSON.parse(localStorage.getItem("hotelWeekend"));
      // Chuyển từ binary sang select
      this.defaultWeekend = this.convertFromBinaryToListSelection(hotelWeekend);
      var tmp = [];
      this.defaultWeekend.forEach(function (element, index) {
        if (element == 1) {
          if (index == 0) {
            tmp.push("MON");
          }
          if (index == 1) {
            tmp.push("TUE");
          }
          if (index == 2) {
            tmp.push("WED");
          }
          if (index == 3) {
            tmp.push("THU");
          }
          if (index == 4) {
            tmp.push("FRI");
          }
          if (index == 5) {
            tmp.push("SAT");
          }
          if (index == 6) {
            tmp.push("SUN");
          }
        }
      });
      this.weekend = tmp;
      var currentDate = moment(this.currentDate);
      this.dateList = [];
      for (let i = 0; i < 15; i++) {
        var isWeekend = tmp.indexOf(currentDate.format("ddd").toUpperCase()) > -1;
        this.dateList.push({
          date: currentDate.format("YYYY-MM-DD"),
          isWeekend: isWeekend,
          dateFormat: this.formatDate(currentDate.format("YYYY-MM-DD"))
        });
        currentDate.add(1, "day");
      }
    },
    convertFromBinaryToListSelection(number) {
      let output = parseInt(number, 10).toString(2);
      while (output.length < 7) {
        output = "0" + output;
      }
      return output.split("");
    },
    async initialize(isSearch) {
      this.isLoading = true;
      this.otaCodeEdit = JSON.parse(localStorage.getItem("currentOTACodeEdit"));
      Promise.all([
        this.getSalePackage(),
        this.getAllRateCategory(),
        this.getAllPlanByRateCategory(),
        this.getAllRoomByRoomCategory(),
        this.getOta(isSearch)
      ]).then(([
        salePackage, 
        rateCategory, 
        planByRateCategory,
        roomCategory,
        ota
      ]) => {
        //salePackage
        this.popupSalePackage.listSalePackageDefault = salePackage.map((x) => {
          return {
            value: x.id,
            text: x.i18ns.find((x) => x.lang == this.defaultI18n).name,
          };
        });
        this.popupSalePackage.listSalePackageDefault = this.popupSalePackage.listSalePackageDefault.filter(
          (x) => x.value
        );

        //rateCategory
        this.listRateCategory = rateCategory.map(x => x.id);


        //planByRateCategory
        const data = [];
        planByRateCategory.forEach(e => {
          if (e.ratePlans.length > 0) {
            data.push({
              id: e.rateCategoryId ? e.rateCategoryId : -1,
              label: e.rateCategoryI18ns.find(l => l.lang === this.defaultI18n) ? e.rateCategoryI18ns.find(l => l.lang === this.defaultI18n).name : e.nameVi,
              children: e.ratePlans.map(pl => Object.assign({}, {
                id: pl.id,
                label: pl.ratePlanI18n.find(l => l.lang === this.defaultI18n) ? pl.ratePlanI18n.find(l => l.lang === this.defaultI18n).name : pl.nameVi,
              }))
            })
          }
        })
        this.listRatePlanByRateCategory = [...data];
        
        //ota
        this.listOTA = ota.map(x => {
          return {
            value: x.id,
            text: x.otaI18n.find(y => y.lang == this.defaultI18n).name,
            date: this.inDays(new Date(), new Date(x.endDate)),
            endDate: moment(x.endDate).format("DD/MM/YYYY"),
            code: x.otaCode
          };
        });
        this.listOTA = this.listOTA.filter(x => x.value);
        this.listOTA.sort((a, b) => a.text.localeCompare(b.text));
        this.selectedOTA = localStorage.getItem("currentOTARoomSale")
          ? JSON.parse(localStorage.getItem("currentOTARoomSale"))
          : null;
        // Gán OTA đầu tiên để sử dụng lần đầu tiên, với điều kiện có list OTA và chưa tồn tại OTA trong local storage
        if (
          (this.listOTA.length > 0 &&
            this.listOTA[0].value &&
            this.selectedOTA == null) ||
          !this.listOTA.find(x => x.value == this.selectedOTA)
        ) {
          this.selectedOTA = this.listOTA[0].value;
        }
        localStorage.setItem(
          "currentOTACodeEdit",
          JSON.stringify(this.listOTA.find(x => this.selectedOTA === x.value).code)
        );

        // roomCategory
        this.listRoomCategory = roomCategory.map(x => x.roomCategoryId);
          const data01 = [];
          roomCategory.forEach(e => {
            if (e.roomTypes.length > 0) {
              data01.push({
                id: e.roomCategoryId ? e.roomCategoryId : -1,
                label: e.roomCategoryI18ns.find(l => l.lang === this.defaultI18n) ? e.roomCategoryI18ns.find(l => l.lang === this.defaultI18n).name : e.nameVi,
                children: e.roomTypes.map(pl => Object.assign({}, {
                  id: pl.id,
                  label: pl.roomTypeI18n.find(l => l.lang === this.defaultI18n) ? pl.roomTypeI18n.find(l => l.lang === this.defaultI18n).name : pl.nameVi,
                }))
              })
            }
          })
          this.listRoomTypeByRoomCategory = [...data01];
          const local = localStorage.getItem('roomSaleSearch') ? JSON.parse(localStorage.getItem('roomSaleSearch')) : null
          const queryString = window.location.href;
          const ob = JSON.parse(localStorage.getItem("arrToken")).filter(e => e.hotel !== null && e.hotel.id === queryString.split('/')[4])[0];
          if (local && ob.hotel.id === local.hotelId) {
            const allElementsInArray = local.selectedRoom.every(element => this.listRoomTypeByRoomCategory.map(e => e.id).includes(element));
            if(allElementsInArray) {
              this.selectedRoom = local.selectedRoom;
              this.selectedSalePackage = local.selectedSalePackage;
              if (new Date(local.from) >= new Date() ) {
                this.selectedDatePicker = local.from
              } else {
                this.selectedDatePicker = moment().startOf("day").format("YYYY-MM-DD")
              }
            } else {
              this.selectedRoom = this.listRoomTypeByRoomCategory.map(e => e.id);
              this.selectedSalePackage = this.listRatePlanByRateCategory.map(e => e.id);
              this.selectedDatePicker = moment().startOf("day").format("YYYY-MM-DD")
            }
          } else {
            this.selectedRoom = this.listRoomTypeByRoomCategory.map(e => e.id);
            this.selectedSalePackage = this.listRatePlanByRateCategory.map(e => e.id);
            this.selectedDatePicker = moment().startOf("day").format("YYYY-MM-DD")
          }
          
          this.listRoom = [];
          this.listRoomTypeByRoomCategory.forEach(e => {
            e.children.forEach(c => {
              this.listRoom.push({
                value: c.id,
                text: c.label
              });
            })
          });
          this.selectedRoomCalendar = this.listRoom[0].value;
      });
    },
    getAllPlanByRateCategory() {
      return sale_room
        .getAllRatePlanByCategory()
        .then(res => res.data);
    },
    getAllRoomByRoomCategory() {
      return sale_room
        .getAllRoomTypeByCategory()
        .then(res => res.data);
    },
    getAllRateCategory() {
      let body = {};
      body.keyword = "";
      body.status = 1;
      body.limit = 99999;
      body.offset = 0;
      body.orderBy = "ativee";
      body.asc = false;
      return categoryService
        .getRateCategoryList(body)
        .then(res => res.data);
    },
    groupBy(xs, key) {
      return xs.reduce(function (rv, x) {
        (rv[x[key]] = rv[x[key]] || []).push(x);
        return rv;
      }, {});
    },
    getOta(isSearch) {
       return syncota
      .getAllOTA({ keyword: "", status: 1 })
      .then(res => res.data);
    },
    async getAllOTAGroup() {
      await syncota.getAllOTAGroup().then((res) => {
				if (res.responseCode === 0) {
					this.listOTAGroup = res.data.map((x) => {
						return {
							value: x.id,
							text: x.name,
              otas: x.otas
						};
					});
				} else {
					_alert(res, this.$t(res.data), false);
				}
			});
    },
    inDays(d1, d2) {
      var t2 = d2.getTime();
      var t1 = d1.getTime();

      return parseInt((t2 - t1) / (24 * 3600 * 1000));
    },
    changeSearchCondition(value) {
      this.isLoading = true;

      localStorage.setItem("currentOTARoomSale", JSON.stringify(this.selectedOTA));
      localStorage.setItem(
        "currentOTACodeEdit",
        JSON.stringify(this.listOTA.find((x) => this.selectedOTA === x.value).code)
      );
      this.otaCodeEdit = this.listOTA.find((x) => this.selectedOTA === x.value).code;
      this.$forceUpdate;
      this.getRelation(false);
    },
    nextMonth() {
      this.selectedDatePicker = moment(this.selectedDatePicker)
        .add(15, "day")
        .format("YYYY-MM-DD");
      // this.changeDate();
    },
    prevMonth() {
      this.selectedDatePicker = moment(this.selectedDatePicker)
        .add(-15, "day")
        .format("YYYY-MM-DD");

      if (this.selectedDatePicker < moment().startOf("day").format("YYYY-MM-DD")) {
        this.selectedDatePicker = moment().startOf("day").format("YYYY-MM-DD");
      }

      // this.changeDate();
    },
    changeDate() {
     this.oldRalation = this.relationData.map(e => Object.assign({}, {
          id: e.id,
          selectedOta: e.selectedOta,
        }));
      this.getRelation(true);
    },
    addSalePackage(roomId, ratePlans) {
      this.popupSalePackage.roomTypeId = roomId;
      this.popupSalePackage.selectedSalePackage = [];
      this.popupSalePackage.listSalePackage = this.popupSalePackage.listSalePackageDefault;
      this.popupSalePackage.addSalePackageDialog = true;
      // Bỏ các gói bán đã được add trước đó.

      if (ratePlans.length > 0) {
        ratePlans.forEach((e) => {
          this.popupSalePackage.listSalePackage = this.popupSalePackage.listSalePackage.filter(
            (x) => x.value != e.id
          );
        });
      }
    },
    removeSalePackage(data) {
      this.roomUpdate = data.room;
      let body = {
        roomTypeId: data.roomTypeId,
        ratePlanId: data.ratePlanId,
        otaId: data.roomRate.ota.id,
      };

      sale_room
        .removeSalePackage(body)
        .then((res) => {
          _alert(res, this.$t(res.data), false);
          this.getRestrictionByRoomRate(this.roomUpdate);
        })
        .finally(() => (this.popupBatchUpdate.batchUpdateDialog = false));
    },
    removeSpecialPrice(data) {
      // let id = this.relationData
      //   .find((x) => x.id == data.roomTypeId)
      //   .ratePlans.find((y) => y.id == data.ratePlanId)
      //   .roomRates[0].roomRateSpecials.find((z) => z.appliedDate == data.date).id;
      // let body = [id];

      sale_room
        .removeSpecialPrice(data)
        .then((res) => {
          _alert(res, this.$t(res.data), true);
        })
        .finally(() => (this.popupBatchUpdate.batchUpdateDialog = false));
    },
    removeSpecialPriceExtraAdult(data) {
      let id = this.relationData
        .find((x) => x.id == data.roomTypeId)
        .ratePlans.find((y) => y.id == data.ratePlanId)
        .roomRates[0].roomRateSpecials.find((z) => z.appliedDate == data.date).id;
      let body = [id];

      sale_room
        .removeSpecialPriceExtraAdult(body)
        .then((res) => {
          _alert(res, this.$t(res.data), true);
        })
        .finally(() => (this.popupBatchUpdate.batchUpdateDialog = false));
    },
    removeSpecialPriceExtraChild(data) {
      let id = this.relationData
        .find((x) => x.id == data.roomTypeId)
        .ratePlans.find((y) => y.id == data.ratePlanId)
        .roomRates[0].roomRateSpecials.find((z) => z.appliedDate == data.date).id;
      let body = [id];

      sale_room
        .removeSpecialPriceExtraChild(body)
        .then((res) => {
          _alert(res, this.$t(res.data), true);
        })
        .finally(() => (this.popupBatchUpdate.batchUpdateDialog = false));
    },
    removeSpecialPriceExtraBaby(data) {
      let id = this.relationData
        .find((x) => x.id == data.roomTypeId)
        .ratePlans.find((y) => y.id == data.ratePlanId)
        .roomRates[0].roomRateSpecials.find((z) => z.appliedDate == data.date).id;
      let body = [id];

      sale_room
        .removeSpecialPriceExtraBaby(body)
        .then((res) => {
          _alert(res, this.$t(res.data), true);
        })
        .finally(() => (this.popupBatchUpdate.batchUpdateDialog = false));
    },
    getSalePackage() {
      let body = {
        limit: 100,
        offset: 0,
        keyword: "",
        orderBy: "active",
        asc: true,
        status: 1,
      };
      return salePackageService.getAllPlan(body).then(res => res.data);
    },
    confirmSalePackage() {
      if (this.popupSalePackage.selectedSalePackage.length > 0) {
        let body = [];
        this.popupSalePackage.isLoading = true;

        // this.popupSalePackage.applyOTA.forEach( x => {
        this.popupSalePackage.selectedSalePackage.forEach((y) => {
          body.push({
            roomTypeId: this.popupSalePackage.roomTypeId,
            ratePlanId: y,
            otaId: this.selectedOTA,
          });
        });
        // });

        sale_room.addSalePackage(body).then((res) => {
          this.popupSalePackage.isLoading = !this.popupSalePackage.isLoading;
          _alert(res, this.$t(res.data), true);
        });
      } else {
        _alert(null, this.$t("NOT_SELECT_SALE_PACKGE"));
      }
    },
    updateRoomAvail(roomId) {
      localStorage.setItem(
        "roomRateUpdate",
        JSON.stringify({
          roomId: roomId,
          planId: null,
          OtaId: this.selectedOTA,
        })
      );
      this.$router.push({
        name: "roomAvailUpdate",
      });
    },
    updateRoomPrice(roomId) {
      localStorage.setItem(
        "roomRateUpdate",
        JSON.stringify({
          roomId: roomId,
          planId: null,
          OtaId: this.selectedOTA,
        })
      );
      this.$router.push({
        name: "priceRoomSpecialUpdate",
      });
    },
    updateStopSell(roomTypeId, planId, rr, metaData) {
      localStorage.setItem(
        "roomRateUpdate",
        JSON.stringify({
          roomId: roomTypeId,
          planId: planId,
          OtaId: rr.ota.id,
          OtaGroupId: -1
        })
      );
      let routeName = metaData == 'stopSell' ? 'stopSellUpdate' : 'stopSellLimit';
      this.$router.push({
        name: routeName,
      });
    },
    updateRestriction(roomTypeId, roomRateId, rr, meta) {
      localStorage.setItem(
        "roomRateUpdate",
        JSON.stringify({
          roomId: roomTypeId,
          planId: roomRateId,
          OtaId: rr.ota.id,
        })
      );
      this.$router.push({
        name: "restrictionUpdate",
        query: {
          metaData: meta,
        },
      });
    },
    bulkUpdate() {
      localStorage.setItem(
        "roomRateUpdate",
        JSON.stringify({
          roomId: -1,
          planId: -1,
          OtaId: -1,
        })
      );
      this.$router.push({
        name: "priceUpdate",
      });
    },
    updatePrice(roomTypeId, roomRateId, rr) {
      localStorage.setItem(
        "roomRateUpdate",
        JSON.stringify({
          roomId: roomTypeId,
          planId: roomRateId,
          OtaId: rr.ota.id,
        })
      );
      this.$router.push({
        name: "priceUpdate",
      });
    },
    updateSpecialPrice(roomTypeId, roomRateId, rr, metaData) {
      localStorage.setItem(
        "roomRateUpdate",
        JSON.stringify({
          roomId: roomTypeId,
          planId: roomRateId,
          OtaId: rr.ota.id,
        })
      );
      this.$router.push({
        name: "priceExtraUpdate",
        query: {
          metaData: metaData,
        },
      });
    },
    numberFormat(x) {
      if (x !== null) {
        return this.formatCurrency(x);
      }
    },
    priceFormat(val) {
      var value =
        Math.abs(val) > 999999 && Math.abs(val) < 1000000000
          ? `${Math.sign(val) * (Math.abs(val) / 1000000).toFixed(2)}M`
          : Math.abs(val) >= 1000000000
          ? `${Math.sign(val) * (Math.abs(val) / 1000000000).toFixed(2)}B`
          : Math.abs(val) === 0
          ? `0`
          : `${Math.sign(val) * (Math.abs(val) / 1000).toFixed(2)}K`;
      return value;
    },
    priceExtraFormat(meta, date, price) {
      if (price.length > 0) {
        let extraType;
        let finalPrice = null;
        if (meta == "priceExtraAdult") {
          extraType = 0;
        }
        if (meta == "priceExtraChild") {
          extraType = 1;
        }
        if (meta == "priceExtraBaby") {
          extraType = 2;
        }

        var currentDate = moment(date, "YYYY-MM-DD");
        if (!currentDate.isValid()) {
          return "";
        }
        switch (currentDate.day()) {
          case 0: {
            if (price.filter((x) => x.extraType == extraType).length > 0) {
              price
                .filter((x) => x.extraType == extraType)
                .forEach((y) => {
                  if (y.extraSunday) {
                    finalPrice = y.extraSunday;
                  }
                });
            }
            break;
          }
          case 1: {
            if (price.filter((x) => x.extraType == extraType).length > 0) {
              price
                .filter((x) => x.extraType == extraType)
                .forEach((y) => {
                  if (y.extraMonday) {
                    finalPrice = y.extraMonday;
                  }
                });
            }
            break;
          }
          case 2: {
            if (price.filter((x) => x.extraType == extraType).length > 0) {
              finalPrice = price.find((x) => x.extraType == extraType).extraTuesday;
            }
            break;
          }
          case 3: {
            if (price.filter((x) => x.extraType == extraType).length > 0) {
              price
                .filter((x) => x.extraType == extraType)
                .forEach((y) => {
                  if (y.extraWednesday) {
                    finalPrice = y.extraWednesday;
                  }
                });
            }
            break;
          }
          case 4: {
            if (price.filter((x) => x.extraType == extraType).length > 0) {
              price
                .filter((x) => x.extraType == extraType)
                .forEach((y) => {
                  if (y.extraThursday) {
                    finalPrice = y.extraThursday;
                  }
                });
            }
            break;
          }
          case 5: {
            if (price.filter((x) => x.extraType == extraType).length > 0) {
              price
                .filter((x) => x.extraType == extraType)
                .forEach((y) => {
                  if (y.extraFriday) {
                    finalPrice = y.extraFriday;
                  }
                });
            }
            break;
          }
          case 6: {
            if (price.filter((x) => x.extraType == extraType).length > 0) {
              price
                .filter((x) => x.extraType == extraType)
                .forEach((y) => {
                  if (y.extraSaturday) {
                    finalPrice = y.extraSaturday;
                  }
                });
            }
            break;
          }
        }

        if (finalPrice && finalPrice != -1) {
          return this.numberFormat(finalPrice);
        } else {
          return "-";
        }
      } else {
        return "-";
      }
    },
    priceExtraSpecialFormat(meta, date, price) {
      if (price.length > 0) {
        let extraType;
        // let finalPrice = null;
        if (meta == "priceExtraAdult") {
          extraType = 0;
        }
        if (meta == "priceExtraChild") {
          extraType = 1;
        }
        if (meta == "priceExtraBaby") {
          extraType = 2;
        }

        var currentDate = moment(date, "YYYY-MM-DD");
        if (!currentDate.isValid()) {
          return "";
        }

        let tooltip = "";
        var array = this.sortNumberExtra(
          price.filter((x) => x.extraType == extraType && x.appliedDate === date),
          "extraOrder"
        );
        if (array.length > 0) {
          tooltip = this.numberFormat(array[0].pricePax);
        }
        if (tooltip != "") {
          return tooltip;
        } else {
          return " - ";
        }
      } else {
        return " - ";
      }
    },
    tooltipPriceExtraFormat(meta, date, price) {
      if (price.length > 0) {
        let extraType;
        // let finalPrice = null;
        if (meta == "priceExtraAdult") {
          extraType = 0;
        }
        if (meta == "priceExtraChild") {
          extraType = 1;
        }
        if (meta == "priceExtraBaby") {
          extraType = 2;
        }

        var currentDate = moment(date, "YYYY-MM-DD");
        if (!currentDate.isValid()) {
          return "";
        }

        let tooltip = "";
        var array = this.sortNumberExtra(
          price.filter((x) => x.extraType == extraType),
          "extraOrder"
        );
        switch (currentDate.day()) {
          case 0: {
            if (price.filter((x) => x.extraType == extraType).length > 0) {
              array.forEach((y) => {
                if (y.extraSunday) {
                  tooltip =
                    tooltip +
                    '<i class="v-icon notranslate v-icon--link v-icon--left material-icons theme--dark mr-0" style="font-size: 16px;">person</i>' +
                    y.extraOrder +
                    ": " +
                    this.numberFormat(y.extraSunday) +
                    "<br>";
                }
              });
            }
            break;
          }
          case 1: {
            if (price.filter((x) => x.extraType == extraType).length > 0) {
              array.forEach((y) => {
                if (y.extraMonday) {
                  tooltip =
                    tooltip +
                    '<i class="v-icon notranslate v-icon--link v-icon--left material-icons theme--dark mr-0" style="font-size: 16px;">person</i>' +
                    y.extraOrder +
                    ": " +
                    this.numberFormat(y.extraMonday) +
                    "<br>";
                }
              });
            }
            break;
          }
          case 2: {
            if (price.filter((x) => x.extraType == extraType).length > 0) {
              array.forEach((y) => {
                if (y.extraTuesday) {
                  tooltip =
                    tooltip +
                    '<i class="v-icon notranslate v-icon--link v-icon--left material-icons theme--dark mr-0" style="font-size: 16px;">person</i>' +
                    y.extraOrder +
                    ": " +
                    this.numberFormat(y.extraTuesday) +
                    "<br>";
                }
              });
            }
            break;
          }
          case 3: {
            if (price.filter((x) => x.extraType == extraType).length > 0) {
              array.forEach((y) => {
                if (y.extraWednesday) {
                  tooltip =
                    tooltip +
                    '<i class="v-icon notranslate v-icon--link v-icon--left material-icons theme--dark mr-0" style="font-size: 16px;">person</i>' +
                    y.extraOrder +
                    ": " +
                    this.numberFormat(y.extraWednesday) +
                    "<br>";
                }
              });
            }
            break;
          }
          case 4: {
            if (price.filter((x) => x.extraType == extraType).length > 0) {
              array.forEach((y) => {
                if (y.extraThursday) {
                  tooltip =
                    tooltip +
                    '<i class="v-icon notranslate v-icon--link v-icon--left material-icons theme--dark mr-0" style="font-size: 16px;">person</i>' +
                    y.extraOrder +
                    ": " +
                    this.numberFormat(y.extraThursday) +
                    "<br>";
                }
              });
            }
            break;
          }
          case 5: {
            if (price.filter((x) => x.extraType == extraType).length > 0) {
              array.forEach((y) => {
                if (y.extraFriday) {
                  tooltip =
                    tooltip +
                    '<i class="v-icon notranslate v-icon--link v-icon--left material-icons theme--dark mr-0" style="font-size: 16px;">person</i>' +
                    y.extraOrder +
                    ": " +
                    this.numberFormat(y.extraFriday) +
                    "<br>";
                }
              });
            }
            break;
          }
          case 6: {
            if (price.filter((x) => x.extraType == extraType).length > 0) {
              array.forEach((y) => {
                if (y.extraSaturday) {
                  tooltip =
                    tooltip +
                    '<i class="v-icon notranslate v-icon--link v-icon--left material-icons theme--dark mr-0" style="font-size: 16px;">person</i>' +
                    y.extraOrder +
                    ": " +
                    this.numberFormat(y.extraSaturday) +
                    "<br>";
                }
              });
            }
            break;
          }
        }

        if (tooltip != "") {
          return tooltip;
        } else {
          return "";
        }
      } else {
        return "";
      }
    },
    tooltipPriceExtraSpecialFormat(meta, date, price) {
      if (price.length > 0) {
        let extraType;
        // let finalPrice = null;
        if (meta == "priceExtraAdult") {
          extraType = 0;
        }
        if (meta == "priceExtraChild") {
          extraType = 1;
        }
        if (meta == "priceExtraBaby") {
          extraType = 2;
        }

        var currentDate = moment(date, "YYYY-MM-DD");
        if (!currentDate.isValid()) {
          return "";
        }

        let tooltip = "";
        var array = this.sortNumberExtra(
          price.filter((x) => x.extraType == extraType && x.appliedDate === date),
          "extraOrder"
        );
        if (array.length > 0) {
          array.forEach((y) => {
            tooltip =
              tooltip +
              '<i class="v-icon notranslate v-icon--link v-icon--left material-icons theme--dark mr-0" style="font-size: 16px;">person</i>' +
              y.extraOrder +
              ": " +
              this.numberFormat(y.pricePax) +
              "<br>";
          });
        }
        if (tooltip != "") {
          return tooltip;
        } else {
          return "";
        }
      } else {
        return "";
      }
    },
    sortNumberExtra(array, temp) {
      array.sort(function (a, b) {
        return a[temp] - b[temp];
      });
      return array;
    },
    checkWeekend(date) {
      const weekday = ["SUN", "MON", "TUE", "WED", "THU", "FRIFRI", "SAT"];
      let day = weekday[new Date(date).getDay()];
      return this.weekend.includes(day) ? "d-weekend" : "";
    },
    _moment: moment,
  },
  beforeDestroy() {
    window.removeEventListener("resize", this.onResize);
  },
};
</script>
